import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import ChecklistOutlinedIcon from '@mui/icons-material/ChecklistOutlined';
import AllInboxOutlinedIcon from '@mui/icons-material/AllInboxOutlined';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import CallMadeOutlinedIcon from '@mui/icons-material/CallMadeOutlined';
import CallReceivedOutlinedIcon from '@mui/icons-material/CallReceivedOutlined';
import CloseIcon from '@mui/icons-material/Close';
import ContactsIcon from '@mui/icons-material/Contacts';
import IntegrationInstructionsOutlinedIcon from '@mui/icons-material/IntegrationInstructionsOutlined';
import InventoryIcon from '@mui/icons-material/Inventory';
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';
import MoveToInboxOutlinedIcon from '@mui/icons-material/MoveToInboxOutlined';
import PaymentIcon from '@mui/icons-material/Payment';
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import SendOutlinedIcon from '@mui/icons-material/SendOutlined';
import SettingsIcon from '@mui/icons-material/Settings';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import AddIcon from '@mui/icons-material/Add';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import TakeoutDiningOutlinedIcon from '@mui/icons-material/TakeoutDiningOutlined';
import { Box, ButtonBase, Typography, useTheme } from '@mui/material';
import React, { useContext, useEffect, useRef, useState } from "react";
import PublishOutlinedIcon from '@mui/icons-material/PublishOutlined';
import { Link } from "react-router-dom";
import { tokens } from "../../theme";
// import { useAuthUser, useSignOut } from "react-auth-kit";
import { useNavigate } from "react-router-dom";
// import { createRef } from "react";
import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import ScreenShareOutlinedIcon from '@mui/icons-material/ScreenShareOutlined';
import StreamOutlinedIcon from '@mui/icons-material/StreamOutlined';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { Menu, MenuItem, ProSidebar, SubMenu } from 'react-pro-sidebar';
import 'react-pro-sidebar/dist/css/styles.css';
import { useDispatch, useSelector } from "react-redux";
import { MenuStateContext } from "../../contexts/MenuState";
import { useLogoutMutation } from "../../newapi/user/authentication/authApiSlice";
import { hasPermissionForCustomer, isAdminUser, removeCustomerById, removeRelationById, selectAuthStatus, selectCustomers, selectRelations, selectUser, selectUserPermission, UserState } from "../../newapi/user/authentication/authSlice";
import { UserPrivileges } from '../../utils/permissions';
import CloseOverlayBtn from "../theme/buttons/CloseOverlayBtn";
import MLogout from "./Modals/MLogout";
//import AssignmentReturnOutlinedIcon from '@mui/icons-material/AssignmentReturnOutlined';
import AssessmentIcon from '@mui/icons-material/Assessment';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import MAddRelationLogo from "../../components/global/Modals/MAddRelationLogo";
import { enrichBrand } from '../../environments/global/branding/brandConfig';
import { apiSlice } from "../../newapi/createApiSlice";
import { useGetBusinessIntelligenceMenuQuery } from '../../newapi/global/businessIntelligence';
import { clearAllViewInstances } from "../../newapi/global/filter/gridFilterSlice";
import { useGetRelationForMenuQuery } from '../../newapi/global/relation/relationSlice';
import { useGetCustomerBrandQuery } from '../../newapi/global/brandRootSlice';
import { useGetSettingsQuery } from '../../newapi/global/generalApiSlice';
import { selectEnvironmentid, setSelectedEnvironment, setSelectedInnerEnvironment, setSelectedMenuItem, toggleMenu, updateMenuState } from "../../newapi/global/settingsSlice";
import { updateActive } from "../../newapi/warehouse/warehouseSlice";
import { ReactComponent as ReturnPackage } from "../../styles/svg/package-return.svg";
import { hexToRgb } from '../../utils/colorConverters';
import { captureAndOpenFeedback } from '../../utils/openFeedback';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import DashboardIcon from '@mui/icons-material/Dashboard';
import StarIcon from '@mui/icons-material/Star';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import FeedbackOutlinedIcon from '@mui/icons-material/FeedbackOutlined';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import Subheading from '../theme/text/Subheading';
import Text from '../theme/text/Text';
import MOpenRelation from './Modals/MOpenRelation';
import { useGetCustomerLogoQuery } from '../../newapi/user/userSlice';
import { useGetOrderTotalsQuery } from '../../newapi/order/ordersSlice';
import { useGetSupportTicketDashboardQuery } from '../../newapi/warehouse/supportTicketApiSlice';
import { defaultPollingInterval } from '../../utils/constants';
import MenuCountLabel from './MenuCountLabel';

export const typeIconMap = {
  orders: <CallMadeOutlinedIcon />,
  inbounds: <CallReceivedOutlinedIcon/>,
  returns: <ReturnPackage />,
  reports: <AssessmentIcon />,
  dashboards: <DashboardIcon />,
  invoiceinvoiceproducts: <PaymentIcon/>,
  shipments: <LocalShippingOutlinedIcon />,
};
// import DropdownMenu from "./DropdownMenuitem";
// import MenuItem from "./MenuItem";
export const ENV_TYPES = {
    0: "USER",
    100: "COMPANY",
    200: "RELATION",
    300: "DIRECT_ACTION",
    400: "SOFTWARE"
};

export const RELATION_SB_KEYS= {
    page_integrations: "page_integrations",
    page_access: "page_access",
    page_invoices: "page_invoices",
    page_return: "page_return",
    page_inbound: "page_inbound",
    page_orders: "page_orders",
    page_products: "page_products",
    page_servicedesk: "page_servicedesk",
    return_portal_available: "return_portal_available",
    email_templates_available: "email_templates_available"
}

const Item = ({ item, type, title, index, setEnvironment,activeEnvironmentIndex, isDefault, ...rest }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [saveType, setSaveType] = useState(type);
    const dispatch = useDispatch();
    // const temporary = saveType === ENV_TYPES[200];

    useEffect(() => {
        setSaveType(type);
    }, [type]);

    const handleClick = () => {
        if (saveType !== ENV_TYPES[300]) {
            setEnvironment(index);
        } else {
            rest.onClick();
        }
    };

    return (
        <Box
            {...rest}
            className={cx(rest.className, {
                'active': parseInt(activeEnvironmentIndex) === parseInt(index),
                'settings': typeof item !== "undefined" && item.active === "settings",
                'temporary': rest.temporary,
             })}
            sx={{
                mt: `${rest.mt ?? "16px"}`,
                mb: `${rest.mb ?? 0}`,
                ml: 2,
                width: 40,
                height: 40,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                // background: `${colors.nav["linkBg"]}`,
                borderRadius: "100%",
                color: "#fff",
                transition: "250ms",
                cursor: "pointer",
                opacity: 0.3,
                position: "relative",
                
                opacity:1,
                
                "&.temporary:hover .hovermeat" : {
                    borderRadius:3,
                    transition:"250ms !important",
                }
            }}
        >
            {rest.temporary && 
                <>

                    <Box
                        className={cx("hovermeat", {
                            'active': parseInt(activeEnvironmentIndex) === parseInt(index),
                        })}
                        // className="hovermeat"
                        sx={{
                            content: '""',
                            position: "absolute",
                            top: -3,
                            left: -3,
                            width: "calc(100% + 6px)",
                            height: "calc(100% + 6px)",
                            borderRadius: "50%",
                            background:  "conic-gradient(from 0deg, #31415f, #0D61FF, #C2D7FF)",
                            // animation: "spinSparkle 4s linear infinite",
                            // transformOrigin: "center", 
                            filter: "blur(2px)",
                            zIndex: 0, // Behind content
                            transition:"250ms",
                            "&.active" : {
                                background:"unset",
                            }
                        }}
                    />
                    <Box
                        onClick={(e) => {
                            e.stopPropagation();
                            if(parseInt(activeEnvironmentIndex) === parseInt(index)) {
                                setEnvironment(1);
                            } else if(parseInt(index) < parseInt(activeEnvironmentIndex)) {
                                dispatch(setSelectedEnvironment({
                                    selectedEnvironmentIndex: parseInt(activeEnvironmentIndex) - 1
                                }));
                            }
                            if(type === ENV_TYPES[200]){
                                dispatch(removeRelationById(item.id))
                            } else {
                                dispatch(removeCustomerById(item.id))
                            }
                        }}
                        sx={{
                            position:"absolute",
                            width:16,
                            height:16,
                            borderRadius:1.5,
                            background:"#fff",
                            color:"#000",
                            top:"-6px",
                            right:"-6px",
                            display:"flex",
                            alignItems:'center',
                            justifyContent:"center",
                            zIndex:3,
                            fontsize:8,
                        }}
                    >
                        <CloseIcon sx={{
                            fontSize:"14px"
                        }} />
                    </Box>
                </>
            }
            {isDefault &&
                <Box
                    sx={{
                        position:"absolute",
                        width:16,
                        height:16,
                        borderRadius:1.5,
                        background:"#fff",
                        top:"-6px",
                        right:"-6px",
                        display:"flex",
                        alignItems:'center',
                        justifyContent:"center",
                        zIndex:3,
                    }}
                >
                    <StarIcon sx={{
                        fontSize:"12px",
                        color: tokens('dark').blue[400],
                    }} />
                </Box>
            }
             <Box

                onClick={handleClick}
                className={cx(rest.className, {
                    'active': parseInt(activeEnvironmentIndex) === parseInt(index),
                    'settings': typeof item !== "undefined" && item.active === "settings",
                    "temporary": rest.temporary,
                })}
                sx={{
                    width: "100%",
                    height: "100%",
                    background:"#2F3A4E",
                    background: `${colors.nav["linkBg"]}`,
                    zIndex: 1,
                    position: "relative",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#000",
                    borderRadius: "100%",
                    color: "#fff",
                    transition: "250ms",
                    cursor: "pointer",
                    opacity: 0.3,
                    position: "relative",
                    "&.temporary" : {
                    background:"#2F3A4E",
                        
                        zIndex:2,
                        // background:"#2F3A4E",
                        opacity:1,
                    },
                    "&:before": {
                        content: '""',
                        position: "absolute",
                        width: "16px",
                        height: "32px",
                        left: "-28px",
                        top: "4px",
                        background: "transparent",
                        borderRadius: "6px",
                        transition: "250ms",
                    },
                    "&:hover": {
                        opacity: 1,
                        background: theme.palette.mode === "dark" ? `#343438` : "#364563",
                        color: "#fff",
                        transition: "250ms",
                        borderRadius: 3,
                    },
                    "&.active": {
                        opacity: 1,
                        background: "blue",
                        color: `${colors.nav["color"]}`,
                        background: `${colors.blue[400]}`,
                        transition: "250ms",
                        borderRadius: 3,
                        "&.settings" : {
                            background: "#8DFFF8"
                        }
                    },
                    "&.active:before": {
                        background: "#fff",
                        transition: "250ms",
                    },
                    "&.user": {
                        opacity: 1,
                        background: `#7AD7FB`,
                        color: `${colors.nav["color"]}`,
                    },
                    "&.fc": {
                        opacity: 1,
                        background: `${colors.nav["linkBg"]}`,
                        color: "#fff",
                        "&:hover": {
                            color: `${colors.nav["color"]}`,
                            background: `${colors.blue[400]}`,
                        }
                    },
                }}
            >
                {rest.children}
            </Box>
            {/* hello */}
        </Box>
    );
};


const innerTypes = {
    0: "NORMAL",
    100: "SUBMENU",
    200: "SETTINGS",
};

// The blue BETA tag the reporthub button carries, as something a menu link can opt into with `beta: true`
// so it says so in a tag at the end of the row rather than inside its own name.
const BetaTag = () => {
    const {t} = useTranslation();
    return (
        <Box
            sx={{
                height:24,
                display:"flex",
                alignItems:"center",
                px:1,
                flexShrink:0,
                background:tokens("dark").blue[400],
                color:tokens("light").txt["primary"],
                fontSize:12,
                fontWeight:500,
                fontFamily:"Roboto, sans-serif",
                borderRadius:1.5,
            }}
        >
            {t("beta")}
        </Box>
    );
};

const MenuWrapperItem = (props) => {
    // console.log("should render",props);
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const {t} = useTranslation();
    const childRef = useRef(null);
    const type = typeof props.type === "undefined" ? props.link.submenus !== "undefined" ? innerTypes[0] : innerTypes[100] : props.type;
    const { setCollapsed } = useContext(MenuStateContext);
    const dispatch = useDispatch();


    const dropdownOnClick = (e, key) => {
        if (key === props.link.key) {

            let splitted = props.selected && props.selected.includes("_") && props.selected.split("_");
            if((splitted !== null && splitted[0] === props.link.key) || props.selected === key){ 
                props.setSelected(null);
            } else {
                props.setSelected(key);

            }
            
        } else {
            //child
            selectMenuItem(props.link.key + key);
        }
        e.stopPropagation();
    };

    const selectMenuItem = (key) => {
        props.setSelected(key);
        if (window.innerWidth <= 1366) {
            dispatch(toggleMenu());
            // setCollapsed.toggleMenuState();
        }
    };

    const switchInnerEnvironment = (env,newEnvironemnt) => {
        props.switchInnerEnvironment(env,newEnvironemnt);
    }

    if (type === innerTypes[200]) {
        return (
            <MenuItem
                ref={childRef}
                className={cx(props.className, {
                    'active': props.selected === props.link.key,
                })}
                onClick={() => switchInnerEnvironment(props.env,props.newEnvironemnt)}
                icon={props.link.logo}
            >
                <Link to={props.link.to}>{props.link.name}</Link>
            </MenuItem>
        );
    }

    return (
        typeof props.link.submenus === 'undefined' ?
            <MenuItem
                ref={childRef}
                className={cx(props.className, {
                    'active': props.selected === props.link.key,
                })}
                onClick={() => selectMenuItem(props.link.key)}
                // The suffix is pro-sidebar's own slot after the item's content, so a tag put there sits at
                // the row's edge instead of against the name.
                suffix={props.link.beta && <BetaTag/>}
                icon={props.link.logo}>
                <Link
                style={{display:"flex",justifyContent:"space-between"}} to={props.link.to}>
                    {props.link.name}
                    {props.link.new &&
                        <Box sx={{
                            height:24,
                            background: tokens('dark').green[100],
                            color:tokens('dark').green[400],
                            px:1,
                            borderRadius:3,
                            fontWeight:500
                        }}>
                            {t('new')}
                        </Box>
                    }
                    {props.label && props.label}
                </Link>
            </MenuItem>
            :
            <SubMenu 
                ref={childRef} 
                defaultOpen={props.defaultOpen}
                open={props.toOpen}
                onClick={(e) => dropdownOnClick(e, props.link.key)}
                suffix={props.link.beta && <BetaTag/>}

                title={
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            width: '100%',
                        }}
                    >
                        <span>{props.link.name}</span>
                        {props.label && (
                            <Box
                                sx={{
                                    ml: 1,
                                    flexShrink: 0,
                                }}
                            >
                            {props.label}
                            </Box>
                        )}
                    </Box>
                }
                icon={props.link.logo}
           
            >
                {props.link.submenus.map((sublink, index) => (
                    <MenuItem
                        className={props.selected === props.link.key + sublink.key ? "active" : ""}
                        onClick={(e) => dropdownOnClick(e, sublink.key)}
                        suffix={sublink.beta && <BetaTag/>}
                        key={index}>

                        <Link style={{display:"flex",justifyContent:"space-between",alignItems:"center"}} to={sublink.to}>
                            <span style={{flex:1, minWidth:0, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap"}}>
                                {sublink.name}
                            </span>
                            {sublink.primary && <StarIcon style={{fontSize:16, flexShrink:0, color: tokens('dark').blue[400]}} />}
                            {sublink.label}
                            {sublink.new &&
                                <Box sx={{
                                    height:24,
                                    background: tokens('dark').green[100],
                                    color:tokens('dark').green[400],
                                    px:1,
                                    borderRadius:3,
                                    fontWeight:500
                                }}>
                                    {t('new')}
                                </Box>
                            }
                        </Link>
                    </MenuItem>
                ))}
            </SubMenu>
    )
}

const getCustomerShortName = (name) => {
    let splitted = name.split(" ");
    if(splitted.length > 1) {
        return splitted[0].charAt(0) + splitted[1].charAt(0);
    }
    return name.slice(0,2);
}

const CustomerLogo = (props) => {
    // constructor(props) {
    //     super(props);
    //     this.state = {
    //         imgError: false
    //     };
    // }

    // handleImgError = (e) => {
    //     this.setState({ imgError: true });
    //     e.target.onerror = null; // Prevents infinite loop in case of further errors
    // };

    return (
        <>
            {props.customer.name}
        </>
    );
        
}

const getSettingPermissionObject = (permissionState) => {
    const permissionObject = {
        accountingSoftware: selectUserPermission(permissionState, [UserPrivileges.ACCOUNTINGSOFTWARE_MANAGE]),
        carriers: selectUserPermission(permissionState, [UserPrivileges.CARRIER_MANAGE]),
        countingStrategyTemplates: selectUserPermission(permissionState, [UserPrivileges.COUNTINGSTRATEGYTEMPLATE_MANAGE]),
        externalChannels: selectUserPermission(permissionState, [UserPrivileges.EXTERNALCHANNELS_MANAGE]),
        general: selectUserPermission(permissionState, [UserPrivileges.SETTINGS_GENERAL]),
        import: selectUserPermission(permissionState, [UserPrivileges.IMPORT_MANAGE]),
        pickingResources: selectUserPermission(permissionState, [UserPrivileges.PICKINGRESOURCE_READ, UserPrivileges.PICKINGRESOURCE_MANAGE]),
        printers: selectUserPermission(permissionState, [UserPrivileges.PRINTER_READ, UserPrivileges.PRINTER_MANAGE]),
        productFields: selectUserPermission(permissionState, [UserPrivileges.PRODUCTFIELD_MANAGE]),
        shippers: selectUserPermission(permissionState, [UserPrivileges.SHIPPER_READ, UserPrivileges.SHIPPER_MANAGE]),
        streams: selectUserPermission(permissionState, [UserPrivileges.STREAM_READ, UserPrivileges.STREAM_MANAGE]),
        users: selectUserPermission(permissionState, [UserPrivileges.SETTINGS_USERS]),
        userPrivileges: selectUserPermission(permissionState, [UserPrivileges.SETTINGS_USERPRIVILEGES]),
        warehouses: selectUserPermission(permissionState, [UserPrivileges.WAREHOUSE_READ, UserPrivileges.WAREHOUSE_MANAGE]),
        webshopCredentials: selectUserPermission(permissionState, [UserPrivileges.WEBSHOPCREDENTIALS_MANAGE]),
        workspaces: selectUserPermission(permissionState, [UserPrivileges.WORKSPACE_READ, UserPrivileges.WORKSPACE_MANAGE]),
    };

    return permissionObject;
}

const Sidebar = () => {
    // const { t } = useTranslation();
    // const { t, i18n } = useTranslation();
    // additional ready will state if translations are loaded or not
    const { t, ready,i18n } = useTranslation();

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const dispatch = useDispatch();

    const language = useSelector((state) => state.settings.language);
    const selectedMenuItem = useSelector((state) => state.settings.environment.selectedMenuItem);
    const selectedEnvironmentType = useSelector((state) => state.settings.environment.selectedEnvironmentType);
    const selectedEnvironmentActive = useSelector((state) => state.settings.environment.selectedEnvironmentActive);
    const selectedEnvironmentIndex = useSelector((state) => state.settings.environment.selectedEnvironmentIndex);
    

    const navigate = useNavigate();
    const [nav, setNav] = useState([]);

    const authStatus = useSelector(selectAuthStatus);
    const customers = useSelector(selectCustomers);
    const relations = useSelector(selectRelations);
    const user = useSelector(selectUser);

    const selectedEnvironmentId = useSelector(selectEnvironmentid);
    const {data:relationMenuData,isFetching:isFetching2,isLoading:isLoading2} = useGetRelationForMenuQuery(selectedEnvironmentId, {
        skip: selectedEnvironmentType !== ENV_TYPES[200]
    });
    const {data:fulfilmentMenuData,isFetching:isFetchingFulfilment,isLoading:isFulfilmentLoading} = useGetCustomerLogoQuery(selectedEnvironmentId, {
        skip: selectedEnvironmentType !== ENV_TYPES[100]
    });
    // Servicedesk feature toggle. Default disabled — if the setting isn't returned
    // (e.g. not yet stored, or query failed) we treat it as off so the menu hides
    // safely instead of advertising a section that won't load.
    const { data: servicedeskSettings } = useGetSettingsQuery("servicedesk");
    const servicedeskEnabled = !!servicedeskSettings?.some(
        (s) => s.key === "servicedesk_enabled" && (s.value === "true" || s.value === true)
    );

    // Feedback feature toggle, scoped to the active warehouse via the injected
    // warehouse_id header. The feedback circle below only renders when enabled.
    const { data: feedbackSettings } = useGetSettingsQuery("feedback");
    const feedbackEnabled = !!feedbackSettings?.some(
        (s) => s.key === "feedback_enabled" && s.value === "true"
    );

    // Onboarding feature toggle, set from the setup panel. Off until the setting says otherwise,
    // so the menu never shows the page for a customer it was not switched on for.
    const { data: onboardingSettings } = useGetSettingsQuery("onboarding_enabled");
    const onboardingEnabled = !!onboardingSettings?.some(
        (s) => s.key === "onboarding_enabled" && s.value === "true"
    );
    
    const [dominantColor, setDominantColor] = useState('');
    const [logoOpen,setLogoOpen] = useState(false);
  

    // Set permissions WMS
    const hasStockReadPermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.STOCK_PAGE_READ, UserPrivileges.STOCK_READ, UserPrivileges.STOCK_MANAGE])
    );
    const hasReplenishLineReadPermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.REPLENISH_PAGE_READ, UserPrivileges.REPLENISHLINE_READ, UserPrivileges.REPLENISHLINE_MANAGE])
    );
    const hasProductReadPermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.PRODUCTS_PAGE_READ, UserPrivileges.PRODUCT_READ, UserPrivileges.PRODUCT_MANAGE])
    );
    const hasWarehouseLocationReadPermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.WAREHOUSELOCATIONS_PAGE_READ, UserPrivileges.WAREHOUSELOCATION_READ, UserPrivileges.WAREHOUSELOCATION_MANAGE])
    );
    const hasCountingStrategyReadPermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.COUNTINGSTRATEGY_READ, UserPrivileges.COUNTINGSTRATEGY_MANAGE])
    );

    const hasOutboundReadPermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.ORDERS_PAGE_READ, UserPrivileges.OUTBOUND_READ, UserPrivileges.OUTBOUND_MANAGE])
    );

    // Same endpoint (and cache entry) as the "to process" view label on the orders screen,
    // so the menu badge and the tab count always agree.
    const { data: orderTotals } = useGetOrderTotalsQuery("state", {
        skip: selectedEnvironmentType !== ENV_TYPES[100] || !hasOutboundReadPermission,
        pollingInterval: defaultPollingInterval,
    });
    const ordersToProcessCount = orderTotals?.open;

    const hasInboundReadPermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.INBOUNDS_PAGE_READ, UserPrivileges.INBOUND_READ, UserPrivileges.INBOUND_MANAGE])
    );
    const hasReportReadPermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.REPORT_READ])
    );
    const hasDashboardReadPermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.DASHBOARD_READ])
    );

    const hasInboundManagePermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.INBOUNDPROCESSING_PAGE_READ, UserPrivileges.INBOUND_MANAGE])
    );
    const hasReturnReadPermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.RETURNS_PAGE_READ, UserPrivileges.RETURN_READ, UserPrivileges.RETURN_MANAGE])
    );
    const hasReturnManagePermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.RETURN_MANAGE])
    );
    const hasReturnPortalPermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.RETURN_PORTAL])
    );

    const hasEcheckPermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.ECHECK])
    );
    const hasRelationReadPermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.RELATIONS_PAGE_READ, UserPrivileges.RELATION_READ, UserPrivileges.RELATION_MANAGE])
    );
    const hasSupportReadPermission = useSelector((state) =>
        selectUserPermission(state, [UserPrivileges.SUPPORT_READ,UserPrivileges.SUPPORT_MANAGE])
    );
    const hasRelationManagePermission = useSelector((state) =>
        selectUserPermission(state, [UserPrivileges.RELATION_MANAGE])
    );

    const hasWebshopCredentialsReadPermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.CHANNELS_PAGE_READ, UserPrivileges.WEBSHOPCREDENTIALS_READ, UserPrivileges.WEBSHOPCREDENTIALS_MANAGE])
    );
    const hasBackOfficePermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.BACKOFFICE_GENERAL])
    );

    const hasAutomationReadPermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.WORKFLOW_READ, UserPrivileges.WORKFLOW_MANAGE])
    );

    const hasFinancialReadPermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.INVOICEPRODUCT_READ, UserPrivileges.INVOICE_READ, UserPrivileges.INVOICE_MANAGE, UserPrivileges.INVOICEPRODUCT_MANAGE])
    );

    const hasInvoiceReadPermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.INVOICE_PAGE_READ, UserPrivileges.INVOICE_READ, UserPrivileges.INVOICE_MANAGE])
    );

    const hasInvoiceProductReadPermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.INVOICEPARTS_PAGE_READ, UserPrivileges.INVOICEPRODUCT_READ, UserPrivileges.INVOICEPRODUCT_MANAGE])
    );

    const hasInvoiceCategoryReadPermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.INVOICECATEGORY_READ, UserPrivileges.INVOICECATEGORY_MANAGE])
    );

    const hasPriceIncreaseReadPermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.PRICEINCREASE_READ, UserPrivileges.PRICEINCREASE_MANAGE])
    );

    const hasSettingsMenuPermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.SETTINGS_MENU])
    );

    const hasSettingsAllPermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.SETTINGS_ALL])
    );

    const hasSettingsGeneralPermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.SETTINGS_GENERAL])
    );

    const hasSettingsUserPrivilegesPermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.SETTINGS_USERPRIVILEGES])
    );

    // Set permissions Relation portal
    const hasRelationProductPermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.RP_PRODUCT_READ, UserPrivileges.RP_PRODUCT_MANAGE])
    );

    const hasRelationOrderPermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.RP_ORDER_READ, UserPrivileges.RP_ORDER_MANAGE])
    );

    const hasRelationInboundPermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.RP_INBOUND_READ, UserPrivileges.RP_INBOUND_MANAGE])
    );

    const hasRelationInvoicePermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.RP_INVOICE_READ])
    );

    const hasRelationReturnPermission = useSelector((state) =>
        selectUserPermission(state, [UserPrivileges.RP_RETURN_READ, UserPrivileges.RP_RETURN_MANAGE])
    );

    const hasRelationSupportPermission = useSelector((state) =>
        selectUserPermission(state, [UserPrivileges.RP_SUPPORT_READ, UserPrivileges.RP_SUPPORT_MANAGE])
    );

    const hasRelationReturnPortalPermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.RP_RETURN_PORTAL])
    );

    const hasRelationUserPermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.RP_USER_READ, UserPrivileges.RP_USER_MANAGE])
    );

    const hasRelationUsergroupPermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.RP_USERGROUP_READ, UserPrivileges.RP_USERGROUP_MANAGE])
    );

    const hasRelationCompanyInfoPermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.RP_COMPANY_INFO_READ, UserPrivileges.RP_COMPANY_INFO_MANAGE])
    );

    const hasWarehouseSupplierPermission = useSelector((state) =>
        selectUserPermission(state, [UserPrivileges.SUPPLIER_READ, UserPrivileges.SUPPLIER_MANAGE])
    );
    const hasSupplierPermission = useSelector((state) =>
        selectUserPermission(state, [UserPrivileges.RP_SUPPLIER_READ, UserPrivileges.RP_SUPPLIER_MANAGE])
    );

    const hasRelationAddressPermission = useSelector((state) =>
        selectUserPermission(state, [UserPrivileges.RP_ORDER_READ, UserPrivileges.RP_ORDER_MANAGE])
    );

    const hasRelationCanImportPermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.RP_PRODUCT_MANAGE, UserPrivileges.RP_PRODUCT_IMPORT])
    );

    const hasRelationWebshopCredentialsPermission = useSelector((state) => 
        selectUserPermission(state, [UserPrivileges.RP_WEBSHOPCREDENTIALS_MANAGE])
    );

    const isAdmin = useSelector((state) => 
        isAdminUser(state)
    );


    const isFulfilment = useSelector((state) => state.settings.environment.isFulfilment);

    // Same endpoint (and cache entry) as the servicedesk page, so the menu badge and the
    // "Nieuw binnengekomen" view count always agree.
    const { data: servicedeskDashboard } = useGetSupportTicketDashboardQuery({}, {
        skip: selectedEnvironmentType !== ENV_TYPES[100] || !isFulfilment || !servicedeskEnabled || !hasSupportReadPermission,
        pollingInterval: defaultPollingInterval,
    });
    const servicedeskCount = servicedeskDashboard?.data?.unassignedCount;
    const relationCustomerId = useSelector((state) => state.settings.environment.relationCustomerId);

    const shouldFetchBrand = selectedEnvironmentType === ENV_TYPES[100] || selectedEnvironmentType === ENV_TYPES[200];
    const brandCustomerId = selectedEnvironmentType === ENV_TYPES[200] ? relationCustomerId : selectedEnvironmentId;

    const { data: customerBrandData, refetch: refetchCustomerBrand } = useGetCustomerBrandQuery(undefined, {
        skip: !shouldFetchBrand || !brandCustomerId,
    });

    useEffect(() => {
        if (shouldFetchBrand && brandCustomerId) {
            refetchCustomerBrand();
        }
    }, [brandCustomerId, selectedEnvironmentType, shouldFetchBrand, refetchCustomerBrand]);

    useEffect(() => {
        if (!customerBrandData || !shouldFetchBrand) return;
        const slug = Object.keys(customerBrandData)[0];
        const raw = Object.values(customerBrandData)[0];
        if (!slug || !raw) return;
        const enriched = enrichBrand(raw);
        localStorage.setItem("brand_slug", slug);
        localStorage.setItem("brand_data", JSON.stringify(enriched));
        localStorage.setItem("brand_expiry", String(Date.now() + 24 * 60 * 60 * 1000));
    }, [customerBrandData, shouldFetchBrand]);

    const permissionState = useSelector(state => state);
    const settingPermissions = getSettingPermissionObject(permissionState);


    const hasRelationRight  = (key) => {
        if (RELATION_SB_KEYS[key]) {
            const setting = relationMenuData.settings.find(setting => setting.key === key);
            return setting && setting.value === "true";
        }
        return false;
    }

    // const user = useAuthUser()();
    const buildCustomerList = (customers, relations) => {
        // console.log(language);
        let navList = [];
        for(let i = 0; i < customers.length; i++) {
            // Create navitems based on permissions. Dashboard is always included
            const navLinks = [];

            if(hasDashboardReadPermission){
               navLinks.push({
                    logo:<AssessmentOutlinedIcon/>,
                    name: "Dashboard",
                    key:"warehouse-dashboard",
                    to: "/warehouse/dashboard",
                    active: true
                });
            }

            

            // Outbound
            // if (hasOutboundReadPermission) {
            //     navLinks.push({
            //         logo:<CallMadeOutlinedIcon/>,
            //         name: t('outbound'),
            //         to: "/warehouse/outbound",
            //         key:"warehouse-outbound",
            //         active: false,
            //         submenus: [
            //             {
            //                 name: t('dashboard'),
            //                 to: "/warehouse/outbound/dashboard",
            //                 key:"_dashboard",
            //                 active: false,
            //             },
            //             {
            //                 name: t('orders'),
            //                 to: "/warehouse/outbound/orders",
            //                 key:"_orders",
            //                 active: false,
            //             },
            //             {
            //                 name: t('batches'),
            //                 to: "/warehouse/outbound/batches",
            //                 key:"_batches",
            //                 active: false,
            //             },
            //         ]
            //     });
            // }
            if (hasOutboundReadPermission) {
                navLinks.push(
                    {
                        logo:<CallMadeOutlinedIcon/>,
                        name: t('orders'),
                        to: "/warehouse/outbound/orders",
                        key:"warehouse-outbound-orders",
                        active: false,
                        label: <MenuCountLabel count={ordersToProcessCount} />
                    }
                );
                navLinks.push(
                    {
                        logo:<LocalShippingOutlinedIcon/>,
                        name: t('shipments'),
                        to: "/warehouse/outbound/shipments",
                        key:"warehouse-outbound-shipments",
                        active: false
                    }
                );
                // navLinks.push(
                //     {
                //         logo:<FactCheckOutlinedIcon/>,
                //         name: t('batches'),
                //         to: "/warehouse/outbound/batches",
                //         key:"warehouse-outbound-batches",
                //         active: false
                //     }
                // );
            }

            if (hasInboundReadPermission) {
                navLinks.push({
                    logo:<CallReceivedOutlinedIcon/>,
                    name: t('inbounds'),
                    to: "/warehouse/inbound/inbounds",
                    key:"warehouse-inbound-inbounds",
                    active: false
                });

                if (!isFulfilment) {
                    navLinks.push({
                        logo:<TrendingUpIcon/>,
                        name: t('purchase_advice'),
                        beta: true,
                        to: "/warehouse/inbound/purchaseadvice",
                        key:"warehouse-inbound-purchaseadvice",
                        active: false
                    });
                }
            }

            if (hasReturnManagePermission) {
                navLinks.push(
                    {
                        logo:<ReturnPackage/>,
                        name: t('returns'),
                        to: "/warehouse/returns",
                        key:"warehouse-returns",
                        active: false
                    }
                );
            }

            if (hasProductReadPermission) {
                navLinks.push(
                    {
                        logo:<InventoryIcon/>,
                        name: t('products'),
                        to: "/warehouse/stock/products",
                        key:"warehouse-stock-products",
                        active: false,
                    }
                );
            }

            // Inbound
            // if (hasInboundReadPermission) {
            //     navLinks.push({
            //         logo:<CallReceivedOutlinedIcon/>,
            //         name: t('inbound'),
            //         to: "/warehouse/inbound",
            //         key:"warehouse-inbound",
            //         active: false,
            //         submenus: [
            //             {
            //                 name: t('dashboard'),
            //                 to: "/warehouse/inbound/dashboard",
            //                 key:"_dashboard",
            //                 active: false,
            //             },
            //             {
            //                 name: t('inbounds'),
            //                 to: "/warehouse/inbound/inbounds",
            //                 key:"_inbounds",
            //                 active: false,
            //             }
            //         ]
            //     });
            // }

            // Echeck
            if (isFulfilment && (hasRelationReadPermission || hasSupportReadPermission || hasRelationManagePermission)) {
                const relationSubmenus = [
                    ...(hasRelationReadPermission
                        ? [{
                        name: t('overview'),
                        to: "/warehouse/relations/overview",
                        key:"_overview",
                        active: false,
                    }]
                    : []
                    ),
                    ...((servicedeskEnabled && hasSupportReadPermission)
                        ? [{
                            name: t('servicedesk'),
                            to: "/warehouse/relations/servicedesk",
                            key:"_servicedesk",
                            active: false,
                            label: <MenuCountLabel count={servicedeskCount} />,
                        }]
                        : []
                    ),
                    ...(hasRelationManagePermission
                        ? [{
                            name: t('news'),
                            to: "/warehouse/relations/news",
                            key:"_relationnews",
                            active: false,
                        }]
                        : []
                    ),
                ];

                // With a single entry the dropdown collapses to a direct link,
                // matching the previous servicedesk-disabled behaviour.
                if (relationSubmenus.length === 1) {
                    navLinks.push({
                        logo:<ContactsIcon/>,
                        name: t('relations'),
                        to: relationSubmenus[0].to,
                        key:"warehouse-relations",
                        active: false,
                        label: relationSubmenus[0].label,
                    });
                } else if (relationSubmenus.length > 1) {
                    navLinks.push({
                        logo:<ContactsIcon/>,
                        name: t('relations'),
                        to: "/warehouse/relations",
                        key:"warehouse-relations",
                        active: false,
                        // Collapsed by default, so the servicedesk count also shows on the parent.
                        label: <MenuCountLabel count={servicedeskCount} />,
                        submenus: relationSubmenus,
                    });
                }
                // navLinks.push(
                //     ...isFulfilment ? [{
                //         logo:<ContactsIcon/>,
                //         name: t('relations'),
                //         to: "/warehouse/relations",
                //         key:"warehouse-relations",
                //         active: false
                //     }] : [],
                // );
            }
            if (hasWebshopCredentialsReadPermission) {
                navLinks.push({
                    logo:<IntegrationInstructionsOutlinedIcon/>,
                    name: t('webshopcredentials'),
                    to: "/warehouse/webshopcredentials/data",
                    key:"warehouse-webshopcredentials",
                    active: false
                });
            }

            // Financial
            if (isFulfilment && (hasInvoiceReadPermission || hasInvoiceProductReadPermission || hasInvoiceCategoryReadPermission || hasPriceIncreaseReadPermission)) {
                navLinks.push({
                    logo:<PaymentIcon/>,
                    name: t('financial'),
                    to: "/warehouse/financial",
                    key:"warehouse-financial",
                    active: false,
                    submenus: [
                        ...(hasInvoiceReadPermission
                            ? [{
                            name: t('invoices'),
                            to: "/warehouse/financial/invoices",
                            key:"_invoices",
                            active: false,
                        }]
                        : []
                        ),
                        ...((hasInvoiceProductReadPermission || hasInvoiceCategoryReadPermission || hasPriceIncreaseReadPermission)
                            ? [{
                                name: t('components'),
                                to: "/warehouse/financial/components",
                                key:"_invoice_components",
                                active: false,
                            }]
                            : []
                        ),
                    ]
                });
            }

            // Stock
            if (hasStockReadPermission 
                || hasProductReadPermission 
                || hasWarehouseLocationReadPermission 
                || hasCountingStrategyReadPermission 
                || hasReplenishLineReadPermission) {
                const submenus = [];
                navLinks.push({
                    logo:<AllInboxOutlinedIcon/>,
                    name: t('warehouse'),
                    key:"warehouse-stock",
                    to: "/warehouse/stock",
                    active: false,
                    submenus: [
                        ...(hasStockReadPermission
                            ? [{
                            name: t('stock'),
                            to: "/warehouse/stock/stock",
                            key:"_stock",
                            active: false,
                        }] : []),
                        ...(hasWarehouseLocationReadPermission
                            ? [{
                            name: t('warehouse_locations'),
                            to: "/warehouse/stock/locations",
                            key:"_locations",
                            active: false,
                        }] : []),
                        ...(hasReplenishLineReadPermission 
                            ? [{
                                name: t("replenish"),
                                key: "_replenish",
                                to: "/warehouse/stock/replenish",
                                active: false,
                            }]
                            : []
                        ),
                        // {
                        //     name: t("repackingorders"),
                        //     key: "_repackingorders",
                        //     to: "/warehouse/stock/repackingorders",
                        //     active: false,
                        // },
                        ...(hasCountingStrategyReadPermission 
                            ? [{
                                name: t("stock_counts"),
                                key: "_countingstrategies",
                                to: "/warehouse/stock/countingstrategies",
                                active: false,
                            }]
                            : []
                        ),
                    ]
                });
            }

            if (hasReportReadPermission) {
                navLinks.push({
                    logo:<CalendarTodayIcon/>,
                    name: t('daytotals'),
                    key:"warehouse-daytotals",
                    to: "/warehouse/daytotals",
                    active: false,
                })
            }   

            // if (hasAutomationReadPermission) {
            //     navLinks.push({
            //         logo:<AutorenewIcon/>,
            //         name: t('automation'),
            //         to: "/warehouse/automation",
            //         key:"warehouse-automation",
            //         active: false,
            //         submenus: [ 
            
            //             {
            //                 name: t("workflows"),
            //                 key:"_workflows",
            //                 to: "/warehouse/automation/workflows",
            //                 active: false,
            //             }
            //         ]
            //     });
            // }

            // Echeck
            if (hasEcheckPermission) {
                navLinks.push({
                    logo:<SendOutlinedIcon/>,
                    title:t("workspace"),
                    name: t('echeck'),
                    to: "/warehouse/echeck",
                    key:"warehouse-echeck",
                    active: false,
                });
            }
            if (hasInboundManagePermission) {
                navLinks.push({
                    logo:<MoveToInboxOutlinedIcon/>,
                    title: !hasEcheckPermission ? t("workspace") : null,
                    name: t('process_inbounds'),
                    to: "/warehouse/processinbound",
                    key:"warehouse-process-inbound",
                    active: false,
                });
            }
            if (hasReturnReadPermission) {
                navLinks.push({
                    logo:<ReturnPackage/>,
                    title: (!hasEcheckPermission && !hasInboundManagePermission) ? t("workspace") : null,
                    name: t('process_returns'),
                    to: "/warehouse/processreturns",
                    key:"warehouse-process-returns",
                    active: false,
                });
            }
            // if (hasEcheckPermission) {
            //     navLinks.push({
            //         logo:<ReturnPackage/>,
            //         name: t('returns'),
            //         to: "/warehouse/echeck",
            //         key:"warehouse-process-returns",
            //         active: false,
            //     });
            // }

            // Backoffice
            // if (hasBackOfficePermission) {
            //     navLinks.push({
            //         logo:<RoomPreferencesOutlinedIcon />,
            //         name: "Backoffice",
            //         key:"warehouse-backoffice",
            //         to: "/",
            //         active: false
            //     });
            // }

            // alert("hi",customers.length);

            const settingsLinks = [];
            if (hasSettingsMenuPermission) {
                if (onboardingEnabled && (settingPermissions.general || hasSettingsAllPermission)) {
                    settingsLinks.push({
                        logo:<ChecklistOutlinedIcon/>,
                        name: t("onboarding"),
                        key:"warehouse-settings-onboarding",
                        to: "/warehouse/settings/onboarding",
                        active: false
                    });
                }
                if (settingPermissions.general || hasSettingsAllPermission) {
                    settingsLinks.push({
                        logo:<SettingsIcon/>,
                        name: t("general"),
                        key:"warehouse-settings-inbound",
                        to: "/warehouse/settings/general",
                        active: false
                    });

                    
                }

                if (settingPermissions.shippers || hasSettingsAllPermission) {
                    settingsLinks.push({
                        logo:<LocalShippingOutlinedIcon/>,
                        name: t("shippers"),
                        to: "/warehouse/settings/shippers",
                        key:"warehouse-settings-shippers",
                        active: false
                    });
                }

                if (settingPermissions.carriers || hasSettingsAllPermission) {
                    settingsLinks.push({
                        logo:<TakeoutDiningOutlinedIcon/>,
                        name: t("carriers"),
                        key:"_carriers",
                        to: "/warehouse/settings/outbound/carriers",
                        active: false,
                    });
                }

                if (settingPermissions.warehouses || hasSettingsAllPermission) {
                    settingsLinks.push({
                        logo:<WarehouseIcon/>,
                        name: t("warehouses"),
                        to: "/warehouse/settings/warehouses",
                        key:"warehouse-settings-warehouses",
                        active: false
                    });
                }
                if (settingPermissions.general || hasSettingsAllPermission) {
                    settingsLinks.push({
                        logo:<EmailOutlinedIcon/>,
                        name: t("email"),
                        key:"warehouse-settings-email",
                        to: "/warehouse/settings/email",
                        active: false
                    });
                }
                // Outside fulfilment the warehouse buys its own stock, so it manages the suppliers itself.
                if (!isFulfilment && hasWarehouseSupplierPermission) {
                    settingsLinks.push({
                        logo:<LocalShippingOutlinedIcon/>,
                        name: t("suppliers"),
                        key:"warehouse-settings-suppliers",
                        to: "/warehouse/settings/suppliers",
                        active: false
                    });
                }

                if (settingPermissions.pickingResources || settingPermissions.streams || hasSettingsAllPermission) {
                    settingsLinks.push({
                        logo:<StreamOutlinedIcon/>,
                        name: t("picking"),
                        key:"warehouse-settings-picking",
                        active: false,
                        submenus: [ 
                            ...(settingPermissions.streams || hasSettingsAllPermission
                                ? [{
                                name: t("streams"),
                                key:"_streams",
                                to: "/warehouse/settings/picking/streams",
                                active: false,
                            }] : []),
                            ...(settingPermissions.pickingResources || hasSettingsAllPermission
                                ? [{
                                name: t("resources"),
                                key:"_resources",
                                to: "/warehouse/settings/picking/resources",
                                active: false,
                            }] : []),
                            ]
                    });
                }

                if (settingPermissions.productFields || hasSettingsAllPermission) {
                    settingsLinks.push({
                        logo:<InventoryIcon/>,
                        name: t("custom_fields"),
                        key:"warehouse-settings-custom-fields",
                        active: false,
                        submenus: [ 
                            {
                                name: t("products"),
                                key:"_products",
                                to: "/warehouse/settings/customfields/products",
                                active: false,
                            },
                            {
                                name: t("orders"),
                                key:"_orders",
                                to: "/warehouse/settings/customfields/orders",
                                active: false,
                            },
                            {
                                name: t("reasons"),
                                key:"_reasons",
                                to: "/warehouse/settings/customfields/reasons",
                                active: false,
                            },
                        ]
                    });
                }


                // if (settingPermissions.countingStrategyTemplates || hasSettingsAllPermission) {
                //     settingsLinks.push({
                //         logo: <AutorenewIcon/>,
                //         name: t("automation"),
                //         key:"warehouse-settings-automation",
                //         to: "/",
                //         active: false,
                //         submenus: [ 
                //         {
                //             name: t("counting_strategies"),
                //             key:"_countingstrategies",
                //             to: "/warehouse/settings/automation/countingstrategies",
                //             active: false,
                //         },
                //         ]
                //     });
                // }

                if (settingPermissions.accountingSoftware || settingPermissions.webshopCredentials || hasSettingsAllPermission) {
                    settingsLinks.push({
                        logo: <IntegrationInstructionsOutlinedIcon/>,
                        name: t("integrations"),
                        key:"warehouse-settings-integrations",
                        to: "/",
                        active: false,
                        submenus: [ 
                            ...(settingPermissions.webshopCredentials || hasSettingsAllPermission
                                ? [{
                                name: t("saleschannels"),
                                key:"_channels",
                                to: "/warehouse/settings/integrations/saleschannels",
                                active: false,
                            }, {
                                name: t("integrators"),
                                key:"_integrators",
                                to: "/warehouse/settings/integrations/integrators",
                                active: false,
                            }] : []),
                            ...((settingPermissions.accountingSoftware || hasSettingsAllPermission) && isFulfilment
                                ? [{
                                name: t("accounting_software"),
                                key:"_accounting_software",
                                to: "/warehouse/settings/integrations/accountingsoftware",
                                active: false,
                            }] : []),
                            ...(settingPermissions.webshopCredentials || hasSettingsAllPermission
                                ? [{
                                    name: t("openapi"),
                                    key: "_openapi",
                                    to: "/warehouse/settings/integrations/openapi",
                                    active: false,
                                }] : []),
                            ...(settingPermissions.externalChannels || hasSettingsAllPermission
                                ? [{
                                    name: t("externalchannels"),
                                    key: "_externalchannel",
                                    to: "/warehouse/settings/integrations/externalchannels",
                                    active: false,
                                }] : []),
                        ]
                    });
                }

                if (settingPermissions.printers || settingPermissions.workspaces || hasSettingsAllPermission) {
                    settingsLinks.push(
                    {
                        logo:<LocalPrintshopOutlinedIcon/>,
                        name: t("office"),
                        key:"warehouse-settings-office",
                        to: "/",
                        active: false,
                        submenus: [
                            ...(settingPermissions.printers || hasSettingsAllPermission
                                ? [{
                                name: t("printers"),
                                key:"_printers",
                                to: "/warehouse/settings/office/printers",
                                active: false,
                            }] : []),
                            ...(settingPermissions.workspaces || hasSettingsAllPermission
                                ? [{
                                name: t("workspaces"),
                                key:"_workspaces",
                                to: "/warehouse/settings/office/workspaces",
                                active: false,
                            }] : []),
                        ]
                    });
                }

                if (settingPermissions.userPrivileges || settingPermissions.users || hasSettingsAllPermission) {
                    settingsLinks.push({
                        logo:<AdminPanelSettingsOutlinedIcon/>,
                        name: t("access"),
                        key:"warehouse-settings-access",
                        to: "/",
                        active: false,
                        submenus: [
                            ...(settingPermissions.users || hasSettingsAllPermission
                                ? [{
                                name: t("users"),
                                key:"_users",
                                to: "/warehouse/settings/access/users",
                                active: false,
                            }] : []),
                            ...(settingPermissions.userPrivileges || hasSettingsAllPermission
                                ? [{
                                name: t("usergroups"),
                                key:"_usergroups",
                                to: "/warehouse/settings/access/usergroups",
                                active: false,
                            }] : []),
                            ...(settingPermissions.users || hasSettingsAllPermission
                                ? [{
                                name: t("whitelists"),
                                key:"_whitelists",
                                to: "/warehouse/settings/access/whitelists",
                                active: false,
                            }] : []),
                        ]
                    });
                }
                if(!isFulfilment && hasReturnPortalPermission){
                    settingsLinks.push({
                        logo:<ScreenShareOutlinedIcon/>,
                        name: t("return_portal"),
                        key:"_return_portal",
                        to: "/warehouse/settings/returnportal",
                        active: false,
                    })
                }
            }
            

            navList.push({
                id: customers[i].id,
                active: 'core',
                type: ENV_TYPES[100],
                temp:customers[i].temp,
                core: {  
                    background:`${colors.blue[400]}`,
                    color: "rgba(0,0,0,.75)",
                    env:customers[i],
                    title: customers[i].name,
                    logoInner:  <Typography fontSize={16} fontWeight={700}> {getCustomerShortName(customers[i].name)} </Typography>,
                    links : navLinks
                },
                settings: {
                    background:`#8DFFF8`,
                    color: "rgba(0,0,0,.75)",
                    title: 'settings',
                    logoInner: <SettingsOutlinedIcon/>,
                    links : settingsLinks
                },
                stockhubbi: {
                    background:`rgba(141,181,255,.25)`,
                    color: "#8DB5FF",
                    title: 'reporthub',
                    logoInner: <AssessmentOutlinedIcon/>,
                    // links : settingsLinks
                },
            })
        }
        for(let i = 0; i < relations.length; i++) {
            const relationLinks = [{
                logo:<AssessmentOutlinedIcon/>,
                name: "Dashboard",
                key:"relation-dashboard",
                to: "/relation/dashboard",
                active: true
            }];


            if (relationMenuData?.settings && relationMenuData.settings.length > 0 && hasRelationRight(RELATION_SB_KEYS.page_products) &&  hasRelationProductPermission) {
                relationLinks.push({
                    logo:<AllInboxOutlinedIcon/>,
                    name: t('products'),
                    key:"relation-products",
                    to: "/relation/products",
                    active: false,
                });
            }

            if (relationMenuData?.settings && relationMenuData.settings.length > 0 && hasRelationRight(RELATION_SB_KEYS.page_orders) &&  hasRelationOrderPermission) {
                relationLinks.push({
                    logo:<CallMadeOutlinedIcon/>,
                    name: t('orders'),
                    key:"relation-outbound",
                    to: "/relation/outbound",
                    active: false,
                });
            }

            if (relationMenuData?.settings && relationMenuData.settings.length > 0 && hasRelationRight(RELATION_SB_KEYS.page_orders) &&  hasRelationOrderPermission) {
                relationLinks.push({
                    logo:<LocalShippingIcon/>,
                    name: t('shipments'),
                    key:"relation-shipments",
                    to: "/relation/shipments",
                    active: false,
                });
            }

            if (relationMenuData?.settings && relationMenuData.settings.length > 0 && hasRelationRight(RELATION_SB_KEYS.page_inbound) &&  hasRelationInboundPermission) {
                relationLinks.push({
                    logo:<CallReceivedOutlinedIcon/>,
                    name: t('inbound'),
                    key:"relation-inbound",
                    to: "/relation/inbound",
                    active: false,
                });

                relationLinks.push({
                    logo:<TrendingUpIcon/>,
                    name: t('purchase_advice'),
                    beta: true,
                    key:"relation-purchaseadvice",
                    to: "/relation/purchaseadvice",
                    active: false,
                });
            }

             if (relationMenuData?.settings && relationMenuData.settings.length > 0 && hasRelationRight(RELATION_SB_KEYS.page_return) && hasRelationReturnPermission) {
                relationLinks.push({
                    logo:<ReturnPackage/>,
                    name: t('returns'),
                    key:"relation-returns",
                    to: "/relation/returns",
                    active: false,
                });
             }

            if (relationMenuData?.settings && relationMenuData.settings.length > 0 && hasRelationRight(RELATION_SB_KEYS.page_invoices) &&  hasRelationInvoicePermission) {
                relationLinks.push({
                    logo:<ReceiptLongIcon/>,
                    name: t('financial'),
                    to: "/relation/financial/invoices",
                    key:"relation-finanial-invoices",
                    active: false,
                });
            }

            if (relationMenuData?.settings && relationMenuData.settings.length > 0 && hasRelationRight(RELATION_SB_KEYS.page_servicedesk) && hasRelationSupportPermission && servicedeskEnabled) {
                relationLinks.push({
                    logo:<SupportAgentIcon/>,
                    name: t('servicedesk'),
                    key:"relation-servicedesk",
                    to: "/relation/servicedesk",
                    active: false,
                });
            }

            if (relationMenuData?.settings && relationMenuData.settings.length > 0 && hasRelationRight(RELATION_SB_KEYS.page_integrations) && hasRelationWebshopCredentialsPermission) {
                relationLinks.push({
                    logo:<IntegrationInstructionsOutlinedIcon/>,
                    name: t("integrations"),
                    key:"relation-settings-integrations",
                    to: "/",
                    active: false,
                    submenus: [
                        {
                            name: t("saleschannels"),
                            key:"_webshop",
                            to: "/relation/integrations/saleschannels",
                            active: false,
                        },
                       {
                            name: t("integrators"),
                            key:"_integrators",
                            to: "/relation/integrations/integrators",
                            active: false,
                        },
                        {
                            name: t("externalchannels"),
                            key:"_externalchannel",
                            to: "/relation/integrations/externalchannels",
                            active: false,
                        },
                        {
                            name: t("api_connections"),
                            key:"_apiconnections",
                            to: "/relation/integrations/apiconnections",
                            active: false,
                        }
                    ]
                },);
            }

            if (relations[i].temp || (relationMenuData?.settings && relationMenuData.settings.length > 0 && hasRelationRight(RELATION_SB_KEYS.page_access) && (hasRelationUserPermission || hasRelationUsergroupPermission))) {
                relationLinks.push({
                    logo:<AdminPanelSettingsOutlinedIcon/>,
                    name: t("access"),
                    key:"relation-settings-access",
                    to: "/",
                    active: false,
                    submenus: [
                        ...(hasRelationUserPermission ? [{
                            name: t("users"),
                            key:"_users",
                            to: "/relation/settings/access/users",
                            active: false,
                        }] : []),
                        ...(hasRelationUsergroupPermission ? [{
                            name: t("usergroups"),
                            key:"_usergroups",
                            to: "/relation/settings/access/usergroups",
                            active: false,
                        }] : []),
                    ]
                });
            }

            if (relationMenuData?.settings && relationMenuData.settings.length > 0 && 
                (hasRelationCompanyInfoPermission || hasSupplierPermission || hasRelationAddressPermission || (hasRelationReturnPortalPermission && hasRelationRight(RELATION_SB_KEYS.return_portal_available)))
            ) {
                relationLinks.push({
                    logo:<SettingsOutlinedIcon/>,
                    name: t("settings"),
                    key:"relation-settings",
                    to: "/",
                    active: false,
                    submenus: [
                        ...(hasRelationCompanyInfoPermission ? [{
                            name: t("details"),
                            key:"_details",
                            to: "/relation/settings/details",
                            active: false,
                        }] : []),
                        ...(hasSupplierPermission ? [{
                            name: t("suppliers"),
                            key:"_supplier",
                            to: "/relation/settings/suppliers",
                            active: false,
                        }] : []),
                        ...(hasRelationAddressPermission ? [{
                            name: t("addressbook"),
                            key:"_addresses",
                            to: "/relation/settings/addresses",
                            active: false,
                        }] : []),
                        ...(hasRelationCompanyInfoPermission ? [{
                            name: t("email"),
                            key:"_email",
                            to: "/relation/settings/email",
                            active: false,
                        }] : []),
                        ...((hasRelationReturnPortalPermission && hasRelationRight(RELATION_SB_KEYS.return_portal_available)) || hasRelationReturnPermission ? [{
                            name: t("return_portal"),
                            key:"_return_portal",
                            to: "/relation/settings/returnportal",
                            active: false,
                        }] : []),
                    ]
                },);
            }

            navList.push({
                id: relations[i].id,
                // Root relation id, matched against the stored default environment.
                // relations[i].id is the per-customer externalId and is not stable.
                internalId: relations[i].internalId,
                active: 'core',
                type: ENV_TYPES[200],
                temp:relations[i].temp,
                core: {
                    background:`${colors.blue[400]}`,
                    color: "rgba(0,0,0,.75)",
                    env:relations[i],
                    title: <CustomerLogo customer={relations[i]}  />,
                    logoInner:  <Typography fontSize={16} fontWeight={700}> {getCustomerShortName(relations[i].name)} </Typography>,
                    links: relationLinks
                },
                // StockHub BI inner-environment. Carries the pre-made reports alongside the builder, which
                // a relation reaches through the same create buttons the warehouse uses.
                ...(hasRelationProductPermission ? {
                    stockhubbi: {
                        background:`rgba(141,181,255,.25)`,
                        color: "#8DB5FF",
                        title: 'reporthub',
                        logoInner: <AssessmentOutlinedIcon/>,
                        links: [{
                            logo:<AssessmentIcon/>,
                            name: t('reports'),
                            key:"relation-stockhubbi-premade",
                            active: false,
                            submenus: [{
                                name: t('never_sold_products'),
                                key:"_neversold",
                                to: "/relation/stockhubbi/report/neversold",
                                active: false,
                            },
                            ...(hasRelationOrderPermission ? [{
                                name: `${t('orders_last_30_days')}`,
                                key:"_ordersoverview",
                                to: "/relation/stockhubbi/dashboard/orders",
                                active: false,
                            }] : [])],
                        }],
                    },
                } : {}),
            })
        }

        if((selectedEnvironmentType === ENV_TYPES[100] || selectedEnvironmentType === ENV_TYPES[200])) {
            navList[selectedEnvironmentIndex-1].active = selectedEnvironmentActive || 'core';
        }


        return navList;
    }

    // Both environments run the same hub, only under their own route prefix.
    const stockhubBiBasePath = selectedEnvironmentType === ENV_TYPES[200]
        ? "/relation/stockhubbi"
        : "/warehouse/stockhubbi";

    const {data:businessList,isLoading:businessLoading,fetching:businessFetching} = useGetBusinessIntelligenceMenuQuery(undefined, {
        skip:nav[selectedEnvironmentIndex]?.active !== "stockhubbi"
    });
    const buildBusinessIntelligenceBoard = (res) => {
        const navItem = nav[selectedEnvironmentIndex];
        // The hub is permission-gated, so the inner env is absent for users who cannot reach it.
        if(!navItem?.stockhubbi) return null;

        let dashboardLinks= [];

        for(var i = 0 ; i < res.dashboards.length; i++) {
            dashboardLinks.push({
                name:res.dashboards[i].name,
                to: stockhubBiBasePath + "/dashboard/" + res.dashboards[i].id,
                key:"_"+res.dashboards[i].id,
                active:false,
                primary: !!res.dashboards[i].isPrimary,
            })
        }

        // The user's primary (home default) dashboard always sits at the top; the rest keep their order.
        dashboardLinks.sort((a, b) => Number(b.primary) - Number(a.primary));

        // Group reports by type
        const groupedReports = res.reports.reduce((acc, report) => {
            const type = report.type || 'orders'; // default to 'orders' if missing
            if (!acc[type]) acc[type] = [];
            acc[type].push(report);
            return acc;
        }, {});

        // Build submenu for each type
        const reportLinks = Object.keys(groupedReports).map((type, idx) => {
            const count = groupedReports[type].length;

            return {
                name: t(type),
                logo: typeIconMap[type] || <AssessmentIcon />,
                ...(idx === 0 && { title: t("stockhubbi_reports") }),
                key: `warehouse-stockhubbi-reports-${type}`,
                active: false,

                label: <MenuCountLabel count={count} />,

                submenus: groupedReports[type].map(report => ({
                    name: report.name,
                    to: stockhubBiBasePath + "/report/" + report.id,
                    key: "_" + report.id,
                    active: false
                }))
            };
        });

        let dashboardMenuLinks = [];
        if(dashboardLinks.length > 0) {
            dashboardMenuLinks = [{
                logo: <AssessmentOutlinedIcon/>,
                name: t('dashboards'),
                to: stockhubBiBasePath + "/dashboards",
                key:"warehouse-stockhubbi-dashboards",
                active:true,
                submenus: dashboardLinks
            }];
        }

        // A refetch rebuilds the same links, so the previous copies are dropped by key before the fresh
        // ones append. Links the response does not build - the relation's pre-made reports - stay put,
        // between the dashboards and the saved reports so the saved reports keep their own heading.
        const menuKeys = new Set([...dashboardMenuLinks, ...reportLinks].map(link => link.key));
        const staticLinks = (navItem.stockhubbi.links ?? []).filter(link => !menuKeys.has(link.key));

        navItem.stockhubbi.links = [
            ...dashboardMenuLinks,
            ...staticLinks,
            ...reportLinks
        ];

        return navItem
    }

    useEffect(() => {
        if(!businessLoading && !businessFetching && businessList) {
            const newNavItem = buildBusinessIntelligenceBoard(businessList);
            if(!newNavItem) return;

            setNav(prev => {
                const updatedNav = [...prev]; // copy the array
                updatedNav[selectedEnvironmentIndex] = newNavItem; // replace by index
                return updatedNav;
            });
        }
    },[businessLoading,businessFetching,businessList])

    // const {auth, authenticated, user} = useAuth();
    
    useEffect(() => {
        if(ready){
            setNav([
                {
                    background:`#7AD7FB`,
                    color: "rgba(0,0,0,.75)",
                    title: user?.name,
                    type: ENV_TYPES[0],
                    logoInner: <PersonOutlinedIcon/>,
                    links : [
                        // {
                        //     logo:<PersonOutlinedIcon/>,
                        //     name: t("Account"),
                        //     active: true,
                        //     submenus: [
                        //         {
                        //             name: t("General"),
                        //             to: "/user/account/general",
                        //             active: true,
                        //         },
                        //         {
                        //             name: t("Security"),
                        //             to: "/user/account/security",
                        //             active: false,
                        //         },
                        //         {
                        //             name: t("Archive"),
                        //             to: "/user/account/archive",
                        //             active: false,
                        //         }
                        //     ]
                        // },
                        {
                            logo:<PersonOutlinedIcon/>,
                            name: t("Account"),
                            key:"account-general",
                            to: "/user/account/general",
                            active: true
                        },
                        // Main-environment picker only makes sense with more than one
                        // permanent environment to choose between; hidden otherwise.
                        ...(((customers?.filter(c => !c.temp).length ?? 0) + (relations?.filter(r => !r.temp).length ?? 0)) > 1 ? [{
                            logo:<ApartmentOutlinedIcon/>,
                            name: t("environments"),
                            key:"account-environments",
                            to: "/user/environments",
                            active: false
                        }] : []),
                        // {
                        //     logo:<SensorDoorOutlinedIcon/>,
                        //     name: t("Accessibility"),
                        //     key:"account-accessibility",
                        //     to: "/user/accessibility",
                        //     active: false
                        // },
                        // {
                        //     logo:<NotificationsActiveOutlinedIcon/>,
                        //     name: t("notifications"),
                        //     key:"account-notifications",
                        //     to: "/user/notifications",
                        //     active: false
                        // }
                    ]
                },
                // ...buildCustomerList(customers ?? [], relations ?? []),

                ...(authStatus === UserState.LOGGED_IN ? buildCustomerList(customers ?? [], relations ?? []) : []),
                ...(user?.sha ? [{
                    type: ENV_TYPES[400],
                    title: "StockHub Software",
                    background: "#565DFF",
                    color: "rgba(255,255,255,1)",
                    logoInner: <SupportAgentIcon/>,
                    core: {
                        title: "StockHub Software",
                        logoInner: <SupportAgentIcon/>
                    },
                    links: [
                        {
                            logo: <ApartmentOutlinedIcon/>,
                            name: t("select_environment"),
                            key: "software-environments",
                            to: "/software/environments",
                            active: true
                        },
                        {
                            logo: <NewspaperIcon/>,
                            name: t("news_and_errors"),
                            key: "software-news",
                            to: "/software/news",
                            active: false
                        },
                        // {
                        //     logo: <ErrorOutlineIcon/>,
                        //     name: t("errors_notifications"),
                        //     key: "software-errors",
                        //     to: "/software/errors",
                        //     active: false
                        // },
                        {
                            logo: <ShoppingCartIcon/>,
                            name: t("software_orders_overview"),
                            key: "software-orders",
                            to: "/software/orders",
                            active: true
                        },
                        {
                            logo: <FeedbackOutlinedIcon/>,
                            name: t("feedback_title"),
                            key: "software-feedback",
                            to: "/software/feedback",
                            active: true
                        }
                    ]
                }] : []),
                {

                    background:`${colors.blue[400]}`,
                    color: "rgba(0,0,0,.75)",
                    title: t("logged_out"),
                    type: ENV_TYPES[300],
                    logoInner: <LogoutOutlinedIcon/>,
                    links : [
                        {
                            logo:<PersonOutlinedIcon/>,
                            name: "Login",
                            to: "/login",
                            active: true
                        },
                    ]
                }
            ]);
            // }
        }
    }, [authStatus,customers,relations,ready,i18n.language,user,selectedEnvironmentIndex,relationMenuData,servicedeskEnabled,onboardingEnabled,ordersToProcessCount,servicedeskCount])

    // Keep the local nav's active inner-env in sync with redux, so switching it from OUTSIDE the sidebar
    // (e.g. a dashboard button dispatching setSelectedInnerEnvironment) also opens that inner-env in the menu.
    useEffect(() => {
        setNav(prev => {
            if (!prev[selectedEnvironmentIndex] || prev[selectedEnvironmentIndex].active === selectedEnvironmentActive) return prev;
            const updated = [...prev];
            updated[selectedEnvironmentIndex] = { ...updated[selectedEnvironmentIndex], active: selectedEnvironmentActive };
            return updated;
        });
    }, [selectedEnvironmentActive, selectedEnvironmentIndex])

    const permissions = useSelector(state => state.auth.permissions);
    const warehouseId = useSelector(state => state.warehouse.activeId);
    const customerWarehouses = useSelector(state => state.auth.customerWarehouses);

    const setEnvironment = (envIndex) => {
        if(selectedEnvironmentIndex !== envIndex){

            // SOFTWARE and USER environments don't have customer/relation context,
            // so we only update type/index and navigate without resetting API state
            // to prevent background queries from losing their customer_id header
            if (nav[envIndex].type === ENV_TYPES[400]) {
                dispatch(setSelectedEnvironment({
                    selectedEnvironmentType: nav[envIndex].type,
                    selectedEnvironmentIndex: envIndex,
                }));
                navigate('/software/environments');
                setSelected("software-environments");
                return;
            }

            let isFulfilment = false;
            let relationCustomerId = 0;
            let relationRootId = 0;
            let foundWarehouseId = null;

            if (nav[envIndex].type === ENV_TYPES[100] && customers.length > 0) {
                const customer = customers.find(c => c.id === nav[envIndex].id);
                if (customer) {
                    isFulfilment = customer.isFulfilment;
                }

                foundWarehouseId = customerWarehouses?.find(x => x.customerId === customer.id)?.warehouseId ?? null;
            } else if (nav[envIndex].type === ENV_TYPES[200] && relations.length > 0) {
                const relation = relations.find(r => r.id === nav[envIndex].id);
                if (relation) {
                    relationCustomerId = relation.customers.length > 0 ? relation.customers[0].id : 0;
                    relationRootId = relation.internalId;
                }
            }

            dispatch(setSelectedEnvironment({
                selectedId: nav[envIndex].id,
                selectedEnvironmentType: nav[envIndex].type,
                selectedEnvironmentIndex: envIndex,
                selectedEnvironmentName: nav[envIndex].core?.env?.name ?? null,
                isFulfilment: isFulfilment,
                relationCustomerId: relationCustomerId,
                relationRootId: relationRootId
            }));

            if (foundWarehouseId) {
                dispatch(updateActive({ id: foundWarehouseId, name: '' }));
            } else {
                dispatch(updateActive({ id: -1, name: t("all_warehouses") }));
            }

            if(nav[envIndex].type === ENV_TYPES[100]){
                // console.log("hasReportReadPermission",hasReportReadPermission);

                const canAccessDashboard = hasPermissionForCustomer({
                    permissions,
                    customerId: nav[envIndex]?.id,
                    warehouseId,
                    requiredPermissions: [UserPrivileges.DASHBOARD_READ]
                });

                //WAREHOUSE
                if(canAccessDashboard){
                    navigate('/warehouse/dashboard'); // Use navigate to go to /warehouse
                    setSelected("warehouse-dashboard");
                } else {
                    navigate('/warehouse/outbound/orders');
                    setSelected("warehouse-outbound-orders");
                }
            } else if (nav[envIndex].type=== ENV_TYPES[200]) {
                //RELATION
                navigate('/relation/dashboard'); // Use navigate to go to /relation
                setSelected("relation-dashboard");
            } else if (nav[envIndex].type === ENV_TYPES[0]) {

                // key:"account-general",
                // to: "/user/account/general",
                navigate('/user/account/general'); // Use navigate to go to /relation
                setSelected("account-general");
            }

            //Resets api state
            dispatch(apiSlice.util.resetApiState());
            dispatch(clearAllViewInstances());
        }
    }
    
    const setSelected = (selected) => {
        if(nav[selectedEnvironmentIndex]?.type === ENV_TYPES[0]) {

        }
        dispatch(setSelectedMenuItem(selected));
        dispatch(clearAllViewInstances());
    }

    useEffect(() => {
        if(selectedEnvironmentType === ENV_TYPES[200]) {
        }
    }, [selectedEnvironmentId,selectedEnvironmentType])

    const collapsed = useSelector((state) => state.settings.environment.collapsed);

    const menuChildRef = useRef();
    const token = useSelector(state => state.auth.refreshToken);
    const [logout, { 
        isSuccess : logOutSuccess, 
        isError: logOutIsError,
        error: logOutError
    }] = useLogoutMutation();

    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);

    const handleLogout = async () => {
        await(logout(token));
    }
    const handleClose = async () => {
        setOpen(false);
    };

    // useEffect(() => {
    //     if(window.innerWidth <= 1368) {
    //         dispatch(toggleMenu());
    //     }
    // },[])
    
    useEffect(() => {
        if(logOutIsError) { 
            return;
        }

        if(logOutSuccess) {
            dispatch(updateMenuState(false));
            // setCollapsed.updateMenuState(false);
            setOpen(false);
            navigate("/login");
            return;
        }
    },[logOutSuccess, logOutIsError,logOutError]);


    useEffect(() => {
        if(!collapsed && window.innerWidth <=1366){
            document.querySelector('meta[name="theme-color"]').setAttribute("content", `${theme.palette.mode === "dark" ? "181820": "#ecf0f5"}`);
            document.querySelector('meta[name="msapplication-navbutton-color"]').setAttribute("content", `${theme.palette.mode === "dark" ? "#181820": "#ecf0f5"}`);
        } else {
            document.querySelector('meta[name="theme-color"]').setAttribute("content", `${theme.palette.mode === "dark" ? colors.bg["secondary"]: colors.bg["primary"]}`);
            document.querySelector('meta[name="msapplication-navbutton-color"]').setAttribute("content", `${theme.palette.mode === "dark" ? colors.bg["secondary"]: colors.bg["primary"]}`);
        }
    },[collapsed,theme.palette.mode])

    const defaultOpenSubMenu = (link) => {
        if(typeof link.submenus !== 'undefined') {
            for(let i = 0; i < link.submenus.length; i++) {
                if(selectedMenuItem === link.key+link.submenus[i].key) {
                    return true;
                }
            }
        }
        return false;
    }

    const openMenu = (link) => {
        if(typeof link.submenus === "undefined") return false;
        if(selectedMenuItem){
            let splitted = selectedMenuItem.split("_");
            if(splitted[0] === link.key) return true;
        }
        return false;
    }

    // const closeMenu = (link) => {
    //     if(typeof link.submenus === "undefined") return false;
    //     let splitted = selectedMenuItem.split("_");
    //     if(splitted[0] === link.key) return false;
    // }

    
    const switchInnerEnvironment = (env,newEnvironemnt) => {
        let index = nav.findIndex(item => (item.type === ENV_TYPES[100] || item.type === ENV_TYPES[200]) && item.core.title === env.core.title);
        if (index !== -1) {
            // Create a new array with the modified company item
            let updatedNav = [...nav];
            if(newEnvironemnt === "settings" || newEnvironemnt === "stockhubbi") {
                updatedNav[index].active = newEnvironemnt;
            }else {
                updatedNav[index].active = "core"
            }
        
            dispatch(setSelectedInnerEnvironment({
                selectedId: updatedNav[index].id,
                selectedEnvironmentType: updatedNav[index].type,
                selectedEnvironmentActive: updatedNav[index].active,
                selectedEnvironmentIndex: index,
            }));
            // dispatch(setSelectedEnvironment({
            //     selectedId: updatedNav[index].id,
            //     selectedEnvironmentType: updatedNav[index].type,
            //     selectedEnvironmentActive: updatedNav[index].active,
            //     selectedEnvironmentIndex: index,
            // }));
            // Update the 'nav' state variable with the modified array
            setNav(updatedNav);
        }
    }

    const beforeSubmenuBarColor = () => {
        if(typeof nav[selectedEnvironmentIndex] === "undefined") return colors.primary[400];

        if(nav[selectedEnvironmentIndex].type === ENV_TYPES[0] || nav[selectedEnvironmentIndex].type === ENV_TYPES[300] || nav[selectedEnvironmentIndex].type === ENV_TYPES[400]) return nav[selectedEnvironmentIndex].background;
        if(nav[selectedEnvironmentIndex].type === ENV_TYPES[200]) return (nav[selectedEnvironmentIndex][nav[selectedEnvironmentIndex].active] ?? nav[selectedEnvironmentIndex].core).background;
        if(nav[selectedEnvironmentIndex].type === ENV_TYPES[100]) return nav[selectedEnvironmentIndex][nav[selectedEnvironmentIndex].active].background;

    }

    const getSecondaryHeaderBackground = () => {
        // console.log("selectedEnvironmentIndex",selectedEnvironmentIndex);
        // console.log("nav",nav[selectedEnvironmentIndex]);
        if(nav[selectedEnvironmentIndex]){
            if(nav[selectedEnvironmentIndex].type === ENV_TYPES[100]) {
                return nav[selectedEnvironmentIndex][nav[selectedEnvironmentIndex].active].background;
            }
            if(nav[selectedEnvironmentIndex].type === ENV_TYPES[200]) {
                return (nav[selectedEnvironmentIndex][nav[selectedEnvironmentIndex].active] ?? nav[selectedEnvironmentIndex].core).background;
            }
            return nav[selectedEnvironmentIndex].background;
        }
        return colors.blue[400]
    }
    
    const getSecondaryHeaderColor = () => {

        if(nav[selectedEnvironmentIndex]){
            if(nav[selectedEnvironmentIndex].type === ENV_TYPES[100]) {
                return nav[selectedEnvironmentIndex][nav[selectedEnvironmentIndex].active].color;
            }
            if(nav[selectedEnvironmentIndex].type === ENV_TYPES[200]) return (nav[selectedEnvironmentIndex][nav[selectedEnvironmentIndex].active] ?? nav[selectedEnvironmentIndex].core).color;
            return nav[selectedEnvironmentIndex].color;
        }
        return colors.blue[400]
    }

    const getSecondaryHeaderLogoInner = () => {
        if(nav[selectedEnvironmentIndex]){
            if(nav[selectedEnvironmentIndex].type === ENV_TYPES[100]) return nav[selectedEnvironmentIndex][nav[selectedEnvironmentIndex].active].logoInner;
            if(nav[selectedEnvironmentIndex].type === ENV_TYPES[200]) return (nav[selectedEnvironmentIndex][nav[selectedEnvironmentIndex].active] ?? nav[selectedEnvironmentIndex].core).logoInner;
            return nav[selectedEnvironmentIndex].logoInner;
        }
        return tokens("light").txt["primary"];
    }

    const changeMenu = () => {
        dispatch(toggleMenu());
    }

    const [addModalOpen, setAddModalOpen] = useState(false);
    const addModal = {
        open: addModalOpen,
        setOpen: setAddModalOpen
    }

    const handleCloseAddModal = () => {
        setAddModalOpen(false);
    };

    // True when this rail environment is the user's chosen main environment.
    // Relations compare on internalId (the root id); customers on id.
    const isDefaultEnvItem = (item) => {
        const defaultEnvironment = user?.defaultEnvironment;
        if (!defaultEnvironment) return false;
        if (item.type === ENV_TYPES[100]) {
            return defaultEnvironment.type === ENV_TYPES[100] && item.id === defaultEnvironment.id;
        }
        if (item.type === ENV_TYPES[200]) {
            return defaultEnvironment.type === ENV_TYPES[200] && item.internalId === defaultEnvironment.id;
        }
        return false;
    };


    return (
        <Box 

            className={cx('menu', {
                'collapsed': collapsed,
            })}
            display="flex"
            sx={{
                position:"fixed",
                height:1,
                top:0,
                width:"342px !important",
                flexShrink: 0,
                height: 1,
            }}
        >

            {/* Main menu */}
            <Box sx={{
                background:  `${colors.bg["primary"]} !important`,
                width:72,
                height: 1,
                paddingY: 3,
                display: "flex",
                flexDirection: "column",
                overflow:"hidden"}}>
                {/* User */}
                {nav.length > 0 ?
                <>
                    <Item
                        index={0}
                        title={nav[0]?.title}
                        activeEnvironmentIndex={selectedEnvironmentIndex}
                        setEnvironment={setEnvironment}
                        className={"user"}
                        type={nav[0].type}
                        mt="0"
                    >
                        {nav[0].logoInner}
                    </Item>

                    {/* Contains our environments */}
                    <Box
                        display="block"
                        flex="1"
                        sx={{
                            mt:3,
                            overflowY:"auto",
                            marginBottom:"40px",
                            marginTop:"24px"
                        }}>
                            {nav.map((item, index) => (
                                index > 0 && index < nav.length-1 && item.type !== ENV_TYPES[400] ?
                                    <Item
                                        key={"nav-env-"+index}
                                        item={item}
                                        type={item.type}
                                        title={item.core.title}
                                        temporary={item.temp}
                                        isDefault={isDefaultEnvItem(item)}
                                        index={index}
                                        activeEnvironmentIndex={selectedEnvironmentIndex}
                                        setEnvironment={setEnvironment}
                                    >
                                        {item.type === ENV_TYPES[100] && index === parseInt(selectedEnvironmentIndex) && fulfilmentMenuData?.logoUrl ?
                                            <Box
                                                sx={{
                                                    width:40,
                                                    flexShrink:0,
                                                    height:40,
                                                    display:"flex",
                                                    borderRadius:"inherit",
                                                    overflow:"hidden",
                                                    justifyContent:"center",
                                                    alignItems:"center",
                                                    transition:"250ms",
                                                    "& img" : {
                                                        background:"rgba(255,255,255,1)",
                                                        height:40,
                                                        width:40,
                                                        objectFit:"cover",
                                                    },
                                                }}
                                            >
                                                <img src={fulfilmentMenuData.logoUrl} alt={item.core.title}/>
                                            </Box>
                                        :
                                            item.core.logoInner
                                        }
                                    </Item>
                                :null
                            ))}

                    </Box>

                    
                    {/* Logoout */}
                    {nav[selectedEnvironmentIndex]?.type === ENV_TYPES[100] && isAdmin &&
                        <Box
                            onClick={() => addModal.setOpen(true)}
                            sx={{
                                cursor:"pointer",
                                mt:1,
                                ml:2,
                                width:40,
                                height:40,
                                borderRadius:"50%",
                                background:tokens("dark").orange[400],
                                transition:"250ms",
                                display:"flex",
                                alignItems:"center",
                                justifyContent:'center',
                                color:tokens("light").txt["primary"],
                                "&:hover" : {
                                    background:tokens("light").orange[400],
                                    color:tokens("dark").txt["primary"],
                                    borderRadius:3,
                                }
                            }}
                        >
                            <ApartmentOutlinedIcon/>
                        </Box>
                    }

                    {user?.sha &&
                        <Box
                            onClick={() => {
                                const softwareIndex = nav.findIndex(n => n.type === ENV_TYPES[400]);
                                if (softwareIndex !== -1) {
                                    setEnvironment(softwareIndex);
                                }
                            }}
                            sx={{
                                cursor:"pointer",
                                mt:1,
                                ml:2,
                                width:40,
                                height:40,
                                position:"relative",
                                borderRadius: parseInt(selectedEnvironmentIndex) === nav.findIndex(n => n.type === ENV_TYPES[400]) ? 3 : "50%",
                                background: parseInt(selectedEnvironmentIndex) === nav.findIndex(n => n.type === ENV_TYPES[400]) ? tokens("light").purple[400] : tokens("dark").purple[400],
                                transition:"250ms",
                                display:"flex",
                                alignItems:"center",
                                justifyContent:'center',
                                color: parseInt(selectedEnvironmentIndex) === nav.findIndex(n => n.type === ENV_TYPES[400]) ? tokens("dark").txt["primary"] : tokens("light").txt["primary"],
                                "&:hover" : {
                                    background:tokens("light").purple[400],
                                    color:tokens("dark").txt["primary"],
                                    borderRadius:3,
                                },
                                "&:before": {
                                    content: '""',
                                    position: "absolute",
                                    width: "16px",
                                    height: "32px",
                                    left: "-28px",
                                    top: "4px",
                                    background: parseInt(selectedEnvironmentIndex) === nav.findIndex(n => n.type === ENV_TYPES[400]) ? "#fff" : "transparent",
                                    borderRadius: "6px",
                                    transition: "250ms",
                                },
                            }}
                        >
                            <SupportAgentIcon/>
                        </Box>
                    }

                    {feedbackEnabled && nav[selectedEnvironmentIndex]?.type === ENV_TYPES[100] &&
                        <Box
                            data-feedback-widget="sidebar"
                            title={t("feedback_title")}
                            onClick={() => captureAndOpenFeedback(dispatch, t)}
                            sx={{
                                cursor:"pointer",
                                mt:1,
                                ml:2,
                                width:40,
                                height:40,
                                borderRadius:"50%",
                                background:`${colors.nav["linkBg"]}`,
                                transition:"250ms",
                                display:"flex",
                                alignItems:"center",
                                justifyContent:'center',
                                color:"#fff",
                                "&:hover" : {
                                    background: theme.palette.mode === "dark" ? `${colors.blue[400]}` : "#364563",
                                    color:"#fff",
                                    borderRadius:3,
                                }
                            }}
                        >
                            <FeedbackOutlinedIcon/>
                        </Box>
                    }

                    <Item
                        className={"fc"}
                        index={nav.length-1}
                        title={nav[nav.length-1].title}
                        type={nav[nav.length-1].type}
                        activeEnvironmentIndex={selectedEnvironmentIndex}
                        onClick={handleOpen}
                        setEnvironment={setEnvironment}
                    >
                        {nav[nav.length-1].logoInner}
                        {/* <LogoutOutlinedIcon/> */}
                    </Item>
                </>
                :null}
            </Box>
            {/* Contextual menu based on what is set up there */}
            <Box
                className="secondary-menu" 
                sx={{
                    // background:"orange",
                    background: `${colors.bg["secondary"]}`,
                    backgroundImage: selectedEnvironmentType === ENV_TYPES[200]  ? `linear-gradient(to top, rgba(${colors.bg["menu"]}, 1), rgba(${relationMenuData?.color ? hexToRgb(JSON.parse(relationMenuData.color).hex) : colors.bg["menu"]}, ${theme.palette.mode === "dark" ? "0.1" : "0.35"}))` : null,
                    width:"270px",
                    height: 1,
                    display:"flex",
                    flexDirection:"column",
                    overflow:"auto",
                    posit:'relative',
                    "& .pro-sidebar" :{
                        minWidth: "unset !important",
                        width: "unset !important",
                        // flex:1,
                        height:((nav[selectedEnvironmentIndex]?.type === ENV_TYPES[100]) && nav[selectedEnvironmentIndex]?.active === "core") ?  "calc(100% - 96px)" : "calc(100% - 96px)",
                    },
                    "& .pro-sidebar-inner": {
                        height:1,
                        minHeight:"100%",
                        background: "none !important",
                        position:"unset",
                        
                        pb:3,
                        "ul" : {
                            height:1,
                            display:"flex",
                            flexDirection:"column",
                        paddingX:"16px !important",
                        },
                        ".pro-menu" : {
                            height:1,
                            paddingY: "0 !important",
                            ".pro-menu-item":{
                                ".pro-inner-item": {
                                    // padding: "5px 35px 5px 35px !important"
                                    
                                    textDecoration:"none",
                                    marginTop:1,
                                    // marginTop:index > 0 ? 1:0,
                                    display:"flex",
                                    alignItems:"center",
                                    paddingLeft:"8px !important",
                                    // The library reserves 35px on the right for the submenu arrow; a row
                                    // without one keeps its content off the edge for nothing.
                                    paddingRight:"8px !important",
                                    height:40,
                                    cursor:"pointer",
                                    borderRadius:3,
                                    color: `${theme.palette.mode === "dark" ? "#88869D" : "rgba(255,255,255,.75)"}`,
                                    transition:"250ms",

                                    "a" : {
                                        color: `${theme.palette.mode === "dark" ? "#88869D" : "rgba(255,255,255,.75)"}`,
                                        transition:"250ms",
                                        "&:hover" : {
                                            color: "#fff !important",
                                            transition:"250ms",
                                            ".pro-arrow" : {
                                                borderColor:"#fff !important",
                                                transition:"250ms"
                                            },
                                        }
                                    },
                                    "&:hover" : {
                                        background: `${colors.nav.linkBg} !important`,
                                        color: "#fff !important",
                                        transition:"250ms",
                                        ".pro-arrow" : {
                                            borderColor:"#fff !important",
                                            transition:"250ms"
                                        },
                                    },
                                    ".pro-arrow" : {
                                        borderColor:`${theme.palette.mode === "dark" ? "#88869D" : "#fff"} !important`,
                                        transition:"250ms"
                                    },
                                    // pro-sidebar drops the suffix in right after the item's text; this sends
                                    // it to the row's right edge, which is where a tag belongs.
                                    "& .suffix-wrapper": {
                                        marginLeft:"auto",
                                        display:"flex",
                                        alignItems:"center",
                                    },
                                    "& .pro-icon-wrapper": {
                                        backgroundColor: "transparent !important",
                                        marginRight:"8px !important",
                                        width:"32px !important",
                                        minWidth: "32px !important",
                                        justifyContent:"center !important",
                                        ".pro-icon" : {
                                            justifyContent:"center !important",
                                            width:20,
                                            "& svg path" : {
                                                fill: `${theme.palette.mode === "dark" ? "#88869D" : "rgba(255,255,255,.75)"}`,
                                            }
                                        }
                                    },
                                },

                                // A group does have an arrow sitting at right:20px, so it keeps the room.
                                "&.pro-sub-menu > .pro-inner-item": {
                                    paddingRight:"35px !important",
                                },

                                ".pro-inner-list-item" : {
                                    paddingLeft: "0px !important",
                                    background:"none !important",
                                    "ul" : {
                                        paddingY: "0px !important",
                                        ".pro-inner-item" : {
                                            marginLeft:"16px !important",
                                            paddingLeft:"16px !important",
                                            paddingRight:"0px !important",
                                            marginTop:"0px !important",
                                            position:"relative",
                                            transition:"250ms",
                                            "&:hover" : {
                                                background: "none !important",
                                                transition:"250ms",
                                            },
                                            "&:before" : {
                                                content: '""',
                                                position:"absolute",
                                                height:"100%",
                                                width:"2px",
                                                left:"-13px !important",
                                                // background:"orange",
                                                borderRadius:2,
                                                background: `${colors.nav.linkBg}`,
                                                transition:"250ms"
                                            }
                                        },
                                        "&:before" : {
                                            content: '""',
                                            position:"absolute",
                                            height:"100%",
                                            width:"2px",
                                            left:19,
                                            borderRadius:2,
                                            background: `${colors.nav.linkBg}`,
                                        }
            
                                    },
                                    ".pro-menu-item.active > .pro-inner-item": {
                                        background: "none ",
                                        color: "#fff !important",
                                        "a": {

                                            color: `#fff !important`,
                                        },
                                        "&:before" :{
                                            left:"-13px",
                                            background:beforeSubmenuBarColor(),
                                            transition:"250ms"
                                        }
                                    },
                                },
                                "&.open > .pro-inner-item, &.active > .pro-inner-item" : {
                                    background: `${colors.nav.linkBg}`,
                                    color: "#fff !important",
                                    transition:"250ms",
                                    ".pro-arrow" : {
                                        borderColor:"#fff !important",
                                        transition:"250ms"
                                    },
                                },
                                "&.active a" :{
                                    color: "#fff !important",
                                    
                                },
                                "&.settings" : {
                                    width:1,
                                    // width:"calc(100% - 32px)",
                                    // position:"absolute",
                                    // bottom:"24px",
                                    // left:"16px",
                                    // marginTop:"auto",
                                   ".pro-inner-item" : { 
                                        background:"rgba(141,255,248,.15)",
                                        borderRadius:"8px",
                                        "& a" : {
                                            fontWeight:500,
                                            color:"rgb(141,255,248) !important"
                                        },
                                        "& .pro-icon-wrapper" : {
                                            color:"rgb(141,255,248) !important"
                                        },
                                        "&:hover" : {
                                            background:"rgba(141,255,248,1) !important",

                                            "& a" : {
                                                color: 'rgba(0,0,0,1) !important'
                                            },
                                            "& .pro-icon-wrapper" : {
                                                color:"rgb(0,0,0,.75) !important"
                                            },

                                        }
                                    }
                                },
                              
                            },
                        },
                        "& .pro-sidebar-layout": {
                            height:1,
                            // overflow:"hidden",
                            position:"unset !important",
                        }
                    },
                    "@media screen and (max-width: 47.9375em)":{
                        flex:1
                    }
                }}>
                    {nav.length > 0 && nav[selectedEnvironmentIndex] ?
                        <>
                        {collapsed ? 
                            <Box onClick={changeMenu}
                                sx={{
                                    "@media screen and (min-width: 1369px)" : {
                                        display:"none",
                                    }
                                }}
                            > 
                            <CloseOverlayBtn></CloseOverlayBtn> 
                            </Box>
                            : 
                            null
                        }
                        
                        {(nav[selectedEnvironmentIndex]?.type === ENV_TYPES[100] || nav[selectedEnvironmentIndex]?.type === ENV_TYPES[200]) && nav[selectedEnvironmentIndex]?.active !== "core" ?
                            <ButtonBase
                                onClick={() => switchInnerEnvironment(nav[selectedEnvironmentIndex])}
                                sx={{
                                    color:"white",
                                    fontSize:14,
                                    // justifyContent:"flex-start",
                                    height:"40px",
                                    width:"40px",
                                    alignItems:"center",
                                    // pl:2,
                                    mx:2,
                                    background:"rgba(255,255,255,.15)",
                                    color:"#fff",
                                    mt:3,
                                    borderRadius:3,
                                    marginBottom:2,
                                    flexShrink:0
                                }}
                            >
                                <ArrowBackIcon fontSize="small"/>
                            </ButtonBase>
                        :null}

                        <Box
                            sx={{
                                paddingX:2,
                                display:"flex",
                                mt:3,
                                mb:4,
                                height:40,
                                alignItems:"center",
                            }}
                        >
                            {selectedEnvironmentType === ENV_TYPES[100] ?
                            <>
                                        
                                        {fulfilmentMenuData?.logoUrl ? 
                                            <Box
                                                sx={{
                                                    width:40,
                                                    flexShrink:0,
                                                    height:40,
                                                    display:"flex",
                                                    borderRadius:5,
                                                    justifyContent: "center",
                                                    alignItems:"center",
                                                    // color: `${nav[environment][nav[environment].active].color}`,
                                                    transition: "250ms",
                                                    "& img" : {
                                                    borderRadius:5,
                                                        // px:0.5,
                                                        background:"rgba(255,255,255,1)",
                                                        height:40,
                                                        maxWidth:40,
                                                        objectFit:"cover",
                                                    },
                                                }}
                                            >
                                                <img src={fulfilmentMenuData?.logoUrl}/> 
                                            </Box>

                                        :
                                            <Box
                                                sx={{
                                                    width:40,
                                                    flexShrink:0,
                                                    height:40,
                                                    display:"flex",
                                                    justifyContent: "center",
                                                    alignItems:"center",
                                                    background: getSecondaryHeaderBackground(),
                                                    // background: `${nav[environment][nav[environment].active].background}`,
                                                    borderRadius:3,
                                                    color: getSecondaryHeaderColor(),
                                                    // color: `${nav[environment][nav[environment].active].color}`,
                                                    transition: "250ms",
                                                }}
                                            >
                                                {getSecondaryHeaderLogoInner()}
                                            </Box>
                                        
                                        }


                                <Box
                                    onClick={() => {
                                        if(selectedEnvironmentType === ENV_TYPES[200]) {
                                            setLogoOpen(true)
                                        }
                                    }}
                                    sx={{
                                        display:"flex",
                                        flexDirection:"column",
                                        overflow:"hidden",
                                        // position:"relative",
                                        // cursor:"pointer",
                                        // "&::before": {
                                        //     content: '""',
                                        //     position: "absolute",
                                        //     left: 0,
                                        //     top: 0,
                                        //     height: '100%',
                                        //     width: '100%',
                                        //     borderRadius:4,
                                        //     background: "transparent",
                                        //     zIndex: 1,
                                        //     pointerEvents: "none",
                                        //     transition: "background 200ms cubic-bezier(0.4, 0, 0.2, 1), border 200ms cubic-bezier(0.4, 0, 0.2, 1)",
                                        // },
                                        // "&:hover&::before": {
                                        //     background: "rgba(0,0,0, 0.2)" 
                                        // }
                                        // background:"orange"
                                    }}
                                >

                                    {(nav[selectedEnvironmentIndex]?.type === ENV_TYPES[100] || nav[selectedEnvironmentIndex]?.type === ENV_TYPES[200]) && nav[selectedEnvironmentIndex]?.active === "stockhubbi" ?
                                    <Typography
                                        sx={{
                                            fontSize:"14px",
                                            fontWeight:400,
                                            color: "rgba(255,255,255,.5)"
                                        }}
                                        marginLeft={2}
                                        component={"span"}
                                    >
                                        {t('reporthub')}
                                        {/* {nav[environment][nav[environment].active].title} */}
                                    </Typography>
                                    :null}
                                    {(nav[selectedEnvironmentIndex]?.type === ENV_TYPES[100]) && nav[selectedEnvironmentIndex]?.active === "settings" ? 
                                    <Typography
                                        sx={{
                                            fontSize:"14px",
                                            fontWeight:400,
                                            color: "rgba(255,255,255,.5)"
                                        }}
                                        marginLeft={2}
                                        component={"span"}
                                    >
                                        {t('settings')}
                                        {/* {nav[environment][nav[environment].active].title} */}
                                    </Typography>
                                    :null}

                                    <Typography
                                        marginLeft={2}
                                        whiteSpace={"nowrap"}
                                        textOverflow={"ellipsis"}
                                        fontSize={17}
                                        fontWeight={700}
                                        color={"#fff"}
                                        component={"span"}
                                        overflow={"hidden"}
                                    >
                                        { (nav[selectedEnvironmentIndex]?.type === ENV_TYPES[100] || nav[selectedEnvironmentIndex]?.type === ENV_TYPES[200]) ? 
                                            nav[selectedEnvironmentIndex]['core'].title 
                                        :
                                            nav[selectedEnvironmentIndex]?.title
                                        }
                                        {/* {nav[environment][nav[environment].active].title} */}
                                    </Typography>
                                </Box>
                                {/* {selectedEnvironmentType === ENV_TYPES[200] &&
                                    <Box
                                        onClick={() => setLogoOpen(true)}
                                        sx={{
                                            ml:"auto",
                                            color:"#fff",
                                            width:32,
                                            height:32,
                                            display:'flex',
                                            alignItems:'center',
                                            justifyContent:"center",
                                            borderRadius:4,
                                            background:"rgba(255,255,255,.15)",
                                        }}
                                    >
                                        <PersonPinCircle/>
                                    </Box>
                                } */}
                            </>
                            :
                            selectedEnvironmentType !== ENV_TYPES[200] || (selectedEnvironmentType === ENV_TYPES[200] && !relationMenuData?.logoUrl) ? 
                                <Box 
                                    onClick={() => setLogoOpen(true)}
                                    sx={{
                                        height:40,
                                        width:1,
                                        borderRadius:5,
                                        transition: "250ms",
                                        display:"flex",
                                        alignItems:"center",
                                        color:"#fff",
                                        fontWeight:700,
                                        fontsize:17,
                                        position:"relative",
                                        cursor:"pointer",

                                        "&::before": {
                                            content: '""',
                                            position: "absolute",
                                            left: 0,
                                            top: 0,
                                            height: '100%',
                                            width: '100%',
                                            borderRadius:4,
                                            background: "transparent",
                                            zIndex: 1,
                                            pointerEvents: "none",
                                            transition: "background 200ms cubic-bezier(0.4, 0, 0.2, 1), border 200ms cubic-bezier(0.4, 0, 0.2, 1)",
                                        },
                                        "&:hover&::before": {
                                            background: "rgba(0,0,0, 0.2)" 
                                        }
                                    }}
                                >

                                    <Box
                                        sx={{
                                            // ml:0.5,
                                            width:40,
                                            flexShrink:0,
                                            height:40,
                                            display:"flex",
                                            justifyContent: "center",
                                            alignItems:"center",
                                            background: getSecondaryHeaderBackground(),
                                            borderRadius:5,
                                            color: getSecondaryHeaderColor(),
                                            transition: "250ms",
                                        }}
                                    >
                                            {getSecondaryHeaderLogoInner()}
                                    </Box>


                                    <Box
                                        onClick={() => {
                                            if(selectedEnvironmentType === ENV_TYPES[200]) {
                                                setLogoOpen(true)
                                            }
                                        }}
                                        sx={{
                                            display:"flex",
                                            flexDirection:"column",
                                            overflow:"hidden",
                                            // position:"relative",
                                            // cursor:"pointer",
                                            // "&::before": {
                                            //     content: '""',
                                            //     position: "absolute",
                                            //     left: 0,
                                            //     top: 0,
                                            //     height: '100%',
                                            //     width: '100%',
                                            //     borderRadius:4,
                                            //     background: "transparent",
                                            //     zIndex: 1,
                                            //     pointerEvents: "none",
                                            //     transition: "background 200ms cubic-bezier(0.4, 0, 0.2, 1), border 200ms cubic-bezier(0.4, 0, 0.2, 1)",
                                            // },
                                            // "&:hover&::before": {
                                            //     background: "rgba(0,0,0, 0.2)" 
                                            // }
                                            // background:"orange"
                                        }}
                                    >
                                        {nav[selectedEnvironmentIndex]?.type === ENV_TYPES[200] && nav[selectedEnvironmentIndex]?.active === "stockhubbi" ?
                                            <Typography
                                                sx={{
                                                    fontSize:"14px",
                                                    fontWeight:400,
                                                    color: "rgba(255,255,255,.5)"
                                                }}
                                                marginLeft={2}
                                                component={"span"}
                                            >
                                                {t('reporthub')}
                                            </Typography>
                                        :
                                            null
                                        }

                                        {(nav[selectedEnvironmentIndex]?.type === ENV_TYPES[100]) && nav[selectedEnvironmentIndex]?.active === "settings" ?
                                            <Typography
                                                sx={{
                                                    fontSize:"14px",
                                                    fontWeight:400,
                                                    color: "rgba(255,255,255,.5)"
                                                }}
                                                marginLeft={2}
                                                component={"span"}
                                            >
                                                {t('settings')}
                                                {/* {nav[environment][nav[environment].active].title} */}
                                            </Typography>
                                        :
                                            null
                                        }

                                        <Typography
                                            marginLeft={2}
                                            whiteSpace={"nowrap"}
                                            textOverflow={"ellipsis"}
                                            fontSize={17}
                                            fontWeight={700}
                                            color={"#fff"}
                                            component={"span"}
                                            overflow={"hidden"}
                                        >
                                            { (nav[selectedEnvironmentIndex]?.type === ENV_TYPES[100] || nav[selectedEnvironmentIndex]?.type === ENV_TYPES[200]) ? 
                                                nav[selectedEnvironmentIndex]['core'].title 
                                            :
                                                nav[selectedEnvironmentIndex]?.title
                                            }
                                            {/* {nav[environment][nav[environment].active].title} */}
                                        </Typography>
                                    </Box>
                                </Box>
                            :
                                <Box 
                                    onClick={() => setLogoOpen(true)}
                                    sx={{
                                        height:40,
                                        width:1,
                                        // background:'rgba(43,96,246,.15)',
                                        borderRadius:5,
                                        transition: "250ms",
                                        display:"flex",
                                        alignItems:"center",
                                        // pl:0.5,
                                        color:"#fff",
                                        fontWeight:700,
                                        fontsize:17,
                                        position:"relative",
                                        cursor:"pointer",

                                        "& img" : {
                                            // px:0.5,
                                            background:"rgba(255,255,255,1)",
                                            // height:40,
                                            borderRadius:5,
                                            mr:1.5,
                                            maxWidth:40,
                                            objectFit:"cover",
                                        },
                                        "&::before": {
                                            content: '""',
                                            position: "absolute",
                                            left: 0,
                                            top: 0,
                                            height: '100%',
                                            width: '100%',
                                            borderRadius:4,
                                            background: "transparent",
                                            zIndex: 1,
                                            pointerEvents: "none",
                                            transition: "background 200ms cubic-bezier(0.4, 0, 0.2, 1), border 200ms cubic-bezier(0.4, 0, 0.2, 1)",
                                        },
                                        "&:hover&::before": {
                                            background: "rgba(0,0,0, 0.2)" 
                                        }
                                    }}
                                >
                                    {/* <img src={relationMenuData?.logoUrl}/> */}
                                    
                                    <Box
                                        sx={{
                                            flexShrink:0,
                                            flex:1,
                                            display:"flex",
                                            alignItems:"center",
                                        }}
                                    >
                                        <img src={relationMenuData?.logoUrl}/>
                                        <Box sx={{display:"flex", flexDirection:"column", justifyContent:"center", overflow:"hidden"}}>
                                            {nav[selectedEnvironmentIndex]?.active === "stockhubbi" &&
                                                <Typography sx={{fontSize:"14px", fontWeight:400, color:"rgba(255,255,255,.5)"}} component={"span"}>
                                                    {t('reporthub')}
                                                </Typography>
                                            }
                                            <span>{nav[selectedEnvironmentIndex]['core']?.title }</span>
                                        </Box>
                                    </Box>

                                </Box>
                            }
                        </Box>

                        <ProSidebar>
                            <Menu iconShape="square">
                                
                                {(nav[selectedEnvironmentIndex]?.type === ENV_TYPES[100]) ?
                                    <>

                                        {nav[selectedEnvironmentIndex][nav[selectedEnvironmentIndex]?.active].links?.map((link, index) => (
                                            <React.Fragment
                                                key={"selectedEnvironmentIndex"+index}
                                            >
                                                {link.title &&
                                                    <Box
                                                        sx={{
                                                            fontSize:14,
                                                            fontFamily:"Roboto,sans-serif",
                                                            mt:3,
                                                        }}
                                                    >
                                                        {link.title}
                                                    </Box>
                                                }
                                                <MenuWrapperItem
                                                    style={{
                                                        marginTop:index > 0 ? 1:0,
                                                        // marginTop:-1
                                                    }}
                                                    forwardRef={menuChildRef}
                                                    // for={menuChildRef}
                                                    key={index}
                                                    toOpen={openMenu(link)}
                                                    // toClose={closeMenu(link)}
                                                    selected={selectedMenuItem}
                                                    setSelected={setSelected}
                                                    defaultOpen={defaultOpenSubMenu(link)}
                                                    link={link}
                                                    label={link.label}
                                                />
                                            </React.Fragment>
                                        ))}

                                        {nav[selectedEnvironmentIndex]?.type === ENV_TYPES[100] && hasReportReadPermission && nav[selectedEnvironmentIndex]?.active === "core" &&
                                            <ButtonBase
                                                onClick={() => {
                                                    switchInnerEnvironment(nav[selectedEnvironmentIndex],"stockhubbi")
                                                }}
                                                component={"li"}
                                                sx={{
                                                    height:40,
                                                    flexShrink:"0",
                                                    mt:"auto",
                                                    display:"flex",
                                                    alignItems:'center',
                                                    px:1,
                                                    background:"rgba(141,181,255,.25)",
                                                    borderRadius:2,
                                                    justifyContent:"flex-start",
                                                    color:"#D9E6FF",
                                                    fontSize:14,
                                                    fontFamily:"Roboto,sans-serif",
                                                    fontWeight:"500",
                                                    "&:hover" : {
                                                    background:"rgba(141,181,255,.35)",

                                                    },
                                                    "@media screen and (max-width: 47.9375em)" : {
                                                        mt:3,
                                                    }
                                                }}
                                            >
                                                <AssessmentOutlinedIcon
                                                    sx={{
                                                        mr:2,
                                                        color:"#8DB5FF",
                                                    }}
                                                />
                                                {t("reporthub")}

                                                {/* <Box
                                                    sx={{
                                                        ml:"auto",
                                                        px:1,
                                                        height:24,
                                                        display:"flex",
                                                        alignItems:'center',
                                                        background:tokens("dark").blue[400],
                                                        color:tokens("light").txt["primary"],
                                                        fontSize:12,
                                                        fontWeight:500,
                                                        fontFamily:"Roboto, sans-serif",
                                                        borderRadius:1.5,
                                                    }}
                                                >
                                                    {t("beta")}
                                                </Box> */}
                                            </ButtonBase>
                                        }

                                        {nav[selectedEnvironmentIndex]?.type === ENV_TYPES[100] && hasSettingsMenuPermission &&( nav[selectedEnvironmentIndex]?.active === "core") &&
                                            <MenuWrapperItem
                                                style={{
                                                    // marginTop:"auto",
                                                    // marginTop:-1
                                                }}
                                                type={innerTypes[200]}
                                                className={"settings"}
                                                // toOpen={openMenu(link)}
                                                link={{
                                                    logo: <SettingsOutlinedIcon/>,
                                                    name:t('settings')
                                                }}
                                                env={nav[selectedEnvironmentIndex]}
                                                newEnvironemnt={"settings"}
                                                switchInnerEnvironment={switchInnerEnvironment}
                                            />
                                        }
                                    </>
                                : nav[selectedEnvironmentIndex]?.type === ENV_TYPES[200] ?
                                    <>
                                    {(nav[selectedEnvironmentIndex]?.[nav[selectedEnvironmentIndex]?.active] ?? nav[selectedEnvironmentIndex]?.core)?.links?.map((link, index) => (
                                        <React.Fragment
                                            key={"selectedEnvironmentIndex"+index}
                                        >
                                            {link.title &&
                                                <Box
                                                    sx={{
                                                        fontSize:14,
                                                        fontFamily:"Roboto,sans-serif",
                                                        mt:3,
                                                    }}
                                                >
                                                    {link.title}
                                                </Box>
                                            }
                                            <MenuWrapperItem
                                                style={{
                                                    marginTop:index > 0 ? 1:0,
                                                    // marginTop:-1
                                                }}
                                                forwardRef={menuChildRef}
                                                // for={menuChildRef}
                                                key={index}
                                                toOpen={openMenu(link)}
                                                selected={selectedMenuItem}
                                                setSelected={setSelected}
                                                defaultOpen={defaultOpenSubMenu(link)}
                                                link={link}
                                                label={link.label}
                                            />
                                        </React.Fragment>
                                    ))}
                                    {/* Enter StockHub BI (view-only pre-made reports) — same blue treatment as the warehouse reporthub switch */}
                                    {nav[selectedEnvironmentIndex]?.stockhubbi && nav[selectedEnvironmentIndex]?.active === "core" &&
                                        <ButtonBase
                                            onClick={() => switchInnerEnvironment(nav[selectedEnvironmentIndex],"stockhubbi")}
                                            component={"li"}
                                            sx={{
                                                height:40,
                                                flexShrink:"0",
                                                mt:"auto",
                                                display:"flex",
                                                alignItems:'center',
                                                px:1,
                                                background:"rgba(141,181,255,.25)",
                                                borderRadius:2,
                                                justifyContent:"flex-start",
                                                color:"#D9E6FF",
                                                fontSize:14,
                                                fontFamily:"Roboto,sans-serif",
                                                fontWeight:"500",
                                                "&:hover" : {
                                                    background:"rgba(141,181,255,.35)",
                                                },
                                            }}
                                        >
                                            <AssessmentOutlinedIcon sx={{ mr:2, color:"#8DB5FF" }} />
                                            {t("reporthub")}
                                            {/* <Box
                                                sx={{
                                                    ml:"auto",
                                                    px:1,
                                                    height:24,
                                                    display:"flex",
                                                    alignItems:'center',
                                                    background:tokens("dark").blue[400],
                                                    color:tokens("light").txt["primary"],
                                                    fontSize:12,
                                                    fontWeight:500,
                                                    fontFamily:"Roboto, sans-serif",
                                                    borderRadius:1.5,
                                                }}
                                            >
                                                {t("beta")}
                                            </Box> */}
                                        </ButtonBase>
                                    }
                                    </>
                                :
                                    nav[selectedEnvironmentIndex]?.links.map((link, index) => (
                                        <MenuWrapperItem
                                        style={{
                                            marginTop:index > 0 ? 1:0,
                                            // marginTop:-1
                                        }}
                                        forwardRef={menuChildRef}
                                        // for={menuChildRef}
                                        key={index}
                                        toOpen={openMenu(link)}
                                        selected={selectedMenuItem}
                                        setSelected={setSelected}
                                        defaultOpen={defaultOpenSubMenu(link)}
                                        link={link}/>
                                    ))
                                }
                                        {(nav[selectedEnvironmentIndex]?.type === ENV_TYPES[100] || nav[selectedEnvironmentIndex]?.type === ENV_TYPES[200]) && nav[selectedEnvironmentIndex]?.active === "stockhubbi" && (
                                            <Box
                                                sx={{
                                                    mt:"auto",
                                                }}
                                            >

                                                {(nav[selectedEnvironmentIndex]?.type === ENV_TYPES[100] ) && nav[selectedEnvironmentIndex]?.active === "stockhubbi" &&
                                                    <Box
                                                        sx={{
                                                            width:"auto",
                                                            background:tokens("dark").orange[100],
                                                            color:tokens("dark").orange[400],
                                                            p:2,

                                                            border: `1px solid ${tokens("dark").orange[400]}`,
                                                            fontWeight:500,
                                                            borderRadius:4,
                                                            mb:2,
                                                        }}
                                                    >
                                                        
                                                        <Subheading color={tokens("dark").orange[400]}>{t("reporthub_beta_title")}</Subheading>
                                                        <Text sx={{mt:0.5,}} color={tokens("dark").txt["primary"]}>{t("reporthub_beta_text")}</Text>
                                                    </Box>
                                                }
                                                {(nav[selectedEnvironmentIndex]?.type === ENV_TYPES[100] || nav[selectedEnvironmentIndex]?.type === ENV_TYPES[200]) && businessList && businessList.reports && businessList.reports.length === 0 && (
                                                      <Box
                                                        sx={{
                                                            width:"auto",
                                                            background:tokens("dark").purple[100],
                                                            color:tokens("dark").purple[400],
                                                            p:2,
                                                            border: `1px solid ${tokens("dark").purple[400]}`,
                                                            fontWeight:500,
                                                            borderRadius:4,
                                                            mb:2,
                                                            py:1,
                                                        }}
                                                    >
                                                    
                                                        <Text sx={{mt:0.5,}} color={tokens("dark").txt["primary"]}>{t("reporthub_beta_start_first_report")}</Text>
                                                    </Box>
                                                )}
                                                {(nav[selectedEnvironmentIndex]?.type === ENV_TYPES[100] || nav[selectedEnvironmentIndex]?.type === ENV_TYPES[200]) &&
                                                    <ButtonBase
                                                        onClick={() => {
                                                            navigate(stockhubBiBasePath + "/dashboard/create");
                                                            dispatch(setSelectedMenuItem("warehouse-stockhubbi-dashboard-create"));
                                                            if(window.innerWidth < 768) {
                                                                changeMenu();
                                                            }
                                                        }}
                                                        component={"li"}
                                                        sx={{
                                                            height:40,
                                                            display:"flex",
                                                            alignItems:'center',
                                                            px:1,
                                                            background:"rgba(255,141,211,.15)",
                                                            borderRadius:2,
                                                            fontsize:14,
                                                            justifyContent:"flex-start",
                                                            color:"#FFD9F0",
                                                            fontsize:14,
                                                            fontFamily:"Roboto,sans-serif",
                                                            fontWeight:"500",
                                                            "&:hover" : {
                                                            background:"rgba(255,141,211,.25)",

                                                            }
                                                        }}
                                                    >
                                                        <AddIcon
                                                            sx={{
                                                                mr:2,
                                                                color:"#FF8DD3",
                                                            }}
                                                        />
                                                        {t("new_dashboard")}
                                                    </ButtonBase>
                                                }
                                                {(nav[selectedEnvironmentIndex]?.type === ENV_TYPES[100] || nav[selectedEnvironmentIndex]?.type === ENV_TYPES[200]) &&
                                                    <ButtonBase
                                                        onClick={() => {
                                                            window.location.href = stockhubBiBasePath + "/report/create";
                                                            // navigate("/warehouse/stockhubbi/report/create");
                                                            dispatch(setSelectedMenuItem("warehouse-stockhubbi-report-create"));
                                                            if(window.innerWidth < 768) {
                                                                changeMenu();
                                                            }
                                                            // switchInnerEnvironment(nav[selectedEnvironmentIndex],"stockhubbi")
                                                        }}
                                                        component={"li"}
                                                        sx={{
                                                            mt:1,
                                                            height:40,
                                                            display:"flex",
                                                            alignItems:'center',
                                                            px:1,
                                                            background:"rgba(141,181,255,.25)",
                                                            borderRadius:2,
                                                            fontsize:14,
                                                            justifyContent:"flex-start",
                                                            color:"#D9E6FF",
                                                            fontsize:14,
                                                            fontFamily:"Roboto,sans-serif",
                                                            fontWeight:"500",
                                                            "&:hover" : {
                                                            background:"rgba(141,181,255,.35)",

                                                            }
                                                        }}
                                                    >
                                                        <AssessmentOutlinedIcon
                                                            sx={{
                                                                mr:2,
                                                                color:"#8DB5FF",
                                                            }}
                                                        />
                                                        {t("new_report")}
                                                    </ButtonBase>
                                                }
                                            </Box>
                                        )}
                            </Menu>
                        </ProSidebar>
                        </>
                    :null}
            </Box>

            <MLogout
                open={open}
                handleLogout={handleLogout}
                handleClose={handleClose}
            />

            {selectedEnvironmentType === ENV_TYPES[200] && 
                <MAddRelationLogo
                    open={logoOpen}
                    handleClose={() => setLogoOpen(false)}
                    relationId={selectedEnvironmentId}
                />
            }

            {nav[selectedEnvironmentIndex]?.type === ENV_TYPES[100] && isAdmin &&
                <MOpenRelation
                    onOpen={() => addModal.setOpen(true)} 
                    onClose={() => addModal.setOpen(false)} 
                    open={addModal.open} 
                    handleClose={handleCloseAddModal} 

                />
            }

        </Box>
    );
};

export default Sidebar;
